import React, { useState, useEffect } from 'react';
import api, { formatApiErrorDetail } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import NotificationModal from '../components/NotificationModal';

const Convocatorias = () => {
  const { user } = useAuth();
  const [showForm, setShowForm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [detalleConvocatoria, setDetalleConvocatoria] = useState(null);
  const [detalleOrdenes, setDetalleOrdenes] = useState([]);
  
  // Unidades de medida comerciales
  const unidadesMedida = [
    { value: 'UN', label: 'UN - Unidad' },
    { value: 'PZ', label: 'PZ - Pieza' },
    { value: 'KG', label: 'KG - Kilogramo' },
    { value: 'GR', label: 'GR - Gramo' },
    { value: 'HG', label: 'HG - Hectogramo' },
    { value: 'TON', label: 'TON - Tonelada' },
    { value: 'M', label: 'M - Metro' },
    { value: 'M2', label: 'M2 - Metro cuadrado' },
    { value: 'M3', label: 'M3 - Metro cúbico' },
    { value: 'LT', label: 'LT - Litro' },
    { value: 'GL', label: 'GL - Galón' },
    { value: 'JA', label: 'JA - Juego' },
    { value: 'SET', label: 'SET - Set' },
    { value: 'PLG', label: 'PLG - Pulgada' },
    { value: 'YD', label: 'YD - Yarda' },
    { value: 'PL', label: 'PL - Par' },
    { value: 'BOL', label: 'BOL - Bolsa' },
    { value: 'CAJ', label: 'CAJ - Caja' },
    { value: 'PT', label: 'PT - Paquete' },
    { value: 'SAC', label: 'SAC - Saco' },
    { value: 'BL', label: 'BL - Bloque' },
    { value: 'CUB', label: 'CUB - Cubo' },
    { value: 'DOC', label: 'DOC - Docena' },
    { value: 'RES', label: 'RES - Resma' }
  ];
  const [searchNroPedido, setSearchNroPedido] = useState('');
  const [searchAnoEje, setSearchAnoEje] = useState(new Date().getFullYear());
  const [pedidos, setPedidos] = useState([]);
  const [selectedPedido, setSelectedPedido] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingConvocatorias, setLoadingConvocatorias] = useState(true);
  const [convocatorias, setConvocatorias] = useState([]);
  const [editingId, setEditingId] = useState(null); // ID de la convocatoria que se está editando
  const [detallesPedidos, setDetallesPedidos] = useState([]); // Detalles de pedidos de SIGA
  const [loadingDetalles, setLoadingDetalles] = useState(false); // Loading para detalles
  const [editingDetalle, setEditingDetalle] = useState(null); // Índice del detalle en edición
  const [detalleData, setDetalleData] = useState({}); // Datos editables de los detalles
  const [ordenesGuardadas, setOrdenesGuardadas] = useState([]); // Órdenes guardadas en la BD
  const [editingOrdenId, setEditingOrdenId] = useState(null); // ID de la orden en edición
  const [ordenEditData, setOrdenEditData] = useState({}); // Datos editables de las órdenes guardadas
  const [especificacionesTecnicasFile, setEspecificacionesTecnicasFile] = useState(null); // Archivo de especificaciones técnicas
  const [uploadingEspecificaciones, setUploadingEspecificaciones] = useState(false); // Estado de carga
  const [uploadProgress, setUploadProgress] = useState(0); // Progreso de carga (0-100)
  const [saveProgress, setSaveProgress] = useState(0); // Progreso de guardado (0-100)
  const [convocatoriaGuardada, setConvocatoriaGuardada] = useState(false); // Indica si la convocatoria se guardó exitosamente
  const [generatingPDF, setGeneratingPDF] = useState(false); // Estado de generación de PDF
  const [formatosPostulacionFile, setFormatosPostulacionFile] = useState(null);
  const [otrosDocumentosFile, setOtrosDocumentosFile] = useState(null);
  const [uploadingFormatosPostulacion, setUploadingFormatosPostulacion] = useState(false);
  const [uploadingOtrosDocumentos, setUploadingOtrosDocumentos] = useState(false);
  const [currentConvocatoria, setCurrentConvocatoria] = useState(null); // Convocatoria actual para mostrar archivos existentes
  const [currentStep, setCurrentStep] = useState(1); // Paso actual del wizard (1-5)
  const [isCreating, setIsCreating] = useState(true); // Indica si estamos en proceso de creación (wizard) o edición
  
  // Estados para búsqueda y filtros
  const [searchTerm, setSearchTerm] = useState('');
  const [filterEstado, setFilterEstado] = useState('');
  const [filterAno, setFilterAno] = useState('');
  const [filterRubro, setFilterRubro] = useState('');
  
  // Estados para notificaciones
  const [notification, setNotification] = useState({
    show: false,
    title: '',
    message: '',
    type: 'info',
    onConfirm: null
  });
  
  // Campos del formulario
  const [formData, setFormData] = useState({
    ano_eje: null,
    sec_ejec: null,
    nombre_ejecutora: '',
    tipo_bien: '',
    tipo_pedido: '',
    nro_pedido: '',
    centro_costo: '',
    nombre_depend: '',
    fecha_pedido: '',
    motivo_pedido: '',
    rubro: 'GENERAL',
    concepto: 'S/N',
    estado: 'ABIERTA',
    fecha_inicio: '',
    fecha_fin: '',
    usuario: user?.id_usuario || null
  });

  // Cargar convocatorias al montar
  useEffect(() => {
    loadConvocatorias();
  }, []);

  const loadConvocatorias = async () => {
    try {
      setLoadingConvocatorias(true);
      const response = await api.get('/api/v1/convocatorias/');
      // Asegurar que siempre sea un array
      const data = Array.isArray(response.data) ? response.data : [];
      setConvocatorias(data);
    } catch (error) {
      console.error('Error loading convocatorias:', error);
      setConvocatorias([]);
    } finally {
      setLoadingConvocatorias(false);
    }
  };

  // Función para filtrar convocatorias
  const getFilteredConvocatorias = () => {
    // Asegurar que convocatorias sea un array
    if (!Array.isArray(convocatorias)) {
      return [];
    }
    
    if (!searchTerm && !filterEstado && !filterAno && !filterRubro) {
      return convocatorias;
    }
    
    return convocatorias.filter(conv => {
      // Filtro por término de búsqueda (busca en múltiples campos)
      const searchLower = searchTerm ? searchTerm.toLowerCase().trim() : '';
      const matchesSearch = !searchLower || 
        (conv.COD_CONVOCATORIA && String(conv.COD_CONVOCATORIA).toLowerCase().includes(searchLower)) ||
        (conv.nro_convocatoria && String(conv.nro_convocatoria).toLowerCase().includes(searchLower)) ||
        (conv.nro_pedido && String(conv.nro_pedido).toLowerCase().includes(searchLower)) ||
        (conv.nombre_ejecutora && String(conv.nombre_ejecutora).toLowerCase().includes(searchLower)) ||
        (conv.motivo_pedido && String(conv.motivo_pedido).toLowerCase().includes(searchLower)) ||
        (conv.rubro && String(conv.rubro).toLowerCase().includes(searchLower)) ||
        (conv.concepto && String(conv.concepto).toLowerCase().includes(searchLower)) ||
        (conv.centro_costo && String(conv.centro_costo).toLowerCase().includes(searchLower)) ||
        (conv.nombre_depend && String(conv.nombre_depend).toLowerCase().includes(searchLower));
      
      // Filtro por estado
      const matchesEstado = !filterEstado || conv.estado === filterEstado;
      
      // Filtro por año
      const matchesAno = !filterAno || String(conv.ano_eje || '') === String(filterAno);
      
      // Filtro por rubro
      const matchesRubro = !filterRubro || (conv.rubro && String(conv.rubro).toLowerCase() === filterRubro.toLowerCase());
      
      return matchesSearch && matchesEstado && matchesAno && matchesRubro;
    });
  };

  // Obtener lista única de estados para el filtro
  const getEstadosUnicos = () => {
    // Asegurar que convocatorias sea un array
    if (!Array.isArray(convocatorias)) {
      return [];
    }
    const estados = [...new Set(convocatorias.map(c => c.estado).filter(Boolean))];
    return estados.sort();
  };

  // Obtener lista única de años para el filtro
  const getAnosUnicos = () => {
    // Asegurar que convocatorias sea un array
    if (!Array.isArray(convocatorias)) {
      return [];
    }
    const anos = [...new Set(convocatorias.map(c => c.ano_eje).filter(Boolean))];
    return anos.sort((a, b) => b - a); // Orden descendente
  };

  // Obtener lista única de rubros para el filtro
  const getRubrosUnicos = () => {
    // Asegurar que convocatorias sea un array
    if (!Array.isArray(convocatorias)) {
      return [];
    }
    const rubros = [...new Set(convocatorias.map(c => c.rubro).filter(Boolean))];
    return rubros.sort();
  };

  // Función para obtener el color del badge según el estado
  const getEstadoBadgeColor = (estado) => {
    switch(estado) {
      case 'ABIERTA':
        return { bg: '#d4edda', color: '#155724', border: '#c3e6cb' };
      case 'CERRADA':
        return { bg: '#fff3cd', color: '#856404', border: '#ffeaa7' };
      case 'EVALUACION':
        return { bg: '#d1ecf1', color: '#0c5460', border: '#bee5eb' };
      case 'FINALIZADA':
        return { bg: '#d1d5db', color: '#374151', border: '#9ca3af' };
      default:
        return { bg: '#e9ecef', color: '#495057', border: '#dee2e6' };
    }
  };

  const searchPedidos = async () => {
    if (!searchNroPedido || !searchAnoEje) {
      setNotification({
        show: true,
        title: 'Campos requeridos',
        message: 'Por favor ingrese número de pedido y año',
        type: 'warning',
        onConfirm: null
      });
      return;
    }

    setLoading(true);
    try {
      const response = await api.get('/api/v1/siga/pedidos', {
        params: {
          nro_pedido: searchNroPedido,
          ano_eje: searchAnoEje
        }
      });
      setPedidos(response.data.pedidos || []);
    } catch (error) {
      console.error('Error searching pedidos:', error);
      setNotification({
        show: true,
        title: 'Error',
        message: 'Error al buscar pedidos',
        type: 'error',
        onConfirm: null
      });
    } finally {
      setLoading(false);
    }
  };

  const selectPedido = (pedido) => {
    setSelectedPedido(pedido);
    setFormData({
      ...formData,
      ano_eje: pedido.ANO_EJE ? parseFloat(pedido.ANO_EJE) : null,
      sec_ejec: pedido.SEC_EJEC ? parseFloat(pedido.SEC_EJEC) : null,
      nombre_ejecutora: pedido.nombre_ejecutora || '',
      tipo_bien: pedido.TIPO_BIEN || '',
      tipo_pedido: pedido.TIPO_PEDIDO || '',
      nro_pedido: pedido.NRO_PEDIDO || '',
      centro_costo: pedido.CENTRO_COSTO || '',
      nombre_depend: pedido.NOMBRE_DEPEND || '',
      fecha_pedido: pedido.FECHA_PEDIDO ? new Date(pedido.FECHA_PEDIDO).toISOString().split('T')[0] : '',
      motivo_pedido: pedido.MOTIVO_PEDIDO || '',
      usuario: user?.id_usuario || null
    });
    // Buscar detalles del pedido y validar antes de avanzar
    loadDetallesPedidos(pedido, true);
  };

  const loadDetallesPedidos = async (pedido, shouldValidate = false) => {
    if (!pedido.ANO_EJE || !pedido.SEC_EJEC || !pedido.TIPO_PEDIDO || !pedido.TIPO_BIEN || !pedido.NRO_PEDIDO) {
      if (shouldValidate) {
        setNotification({
          show: true,
          title: 'Error',
          message: 'El pedido seleccionado no tiene todos los campos necesarios para buscar detalles.',
          type: 'error',
          onConfirm: null
        });
      }
      return;
    }

    setLoadingDetalles(true);
 // Limpiar items agregados al cargar nuevos detalles
    setEditingDetalle(null); // Limpiar edición
    setDetalleData({}); // Limpiar datos editados
    try {
      const response = await api.get('/api/v1/siga/detalle-pedidos', {
        params: {
          ano_eje: pedido.ANO_EJE,
          sec_ejec: pedido.SEC_EJEC,
          tipo_pedido: pedido.TIPO_PEDIDO,
          tipo_bien: pedido.TIPO_BIEN,
          nro_pedido: pedido.NRO_PEDIDO
        }
      });
      const detalles = response.data.detalles || [];
      setDetallesPedidos(detalles);
      
      // Validar si hay items con nombre_item
      if (shouldValidate) {
        const itemsConNombre = detalles.filter(detalle => detalle.NOMBRE_ITEM && detalle.NOMBRE_ITEM.trim() !== '');
        
        if (itemsConNombre.length === 0) {
          setNotification({
            show: true,
            title: 'Validación',
            message: 'El pedido seleccionado no tiene ningún item con "Nombre Item". Por favor, seleccione otro pedido que contenga items válidos.',
            type: 'error',
            onConfirm: () => {
              setSelectedPedido(null);
              setCurrentStep(1);
            }
          });
          setLoadingDetalles(false);
          return;
        }
        
        // Si hay items válidos, avanzar al siguiente paso
        setTimeout(() => {
          setCurrentStep(2);
        }, 500);
      }
    } catch (error) {
      console.error('Error loading detalle pedidos:', error);
      setDetallesPedidos([]);
      if (shouldValidate) {
        setNotification({
          show: true,
          title: 'Error',
          message: 'Error al cargar los detalles del pedido. Por favor, intente nuevamente.',
          type: 'error',
          onConfirm: null
        });
      }
    } finally {
      setLoadingDetalles(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSaveProgress(0);
    
    // Función para actualizar progreso de forma simulada
    const updateProgress = (progress) => {
      setSaveProgress(progress);
    };
    
    try {
      let convocatoriaId = editingId;
      
      if (editingId) {
        // Actualizar convocatoria existente
        updateProgress(20);
        // Solo enviar notificaciones si estamos en el paso 5
        const shouldSendNotifications = currentStep === 5;
        await api.put(`/api/v1/convocatorias/${editingId}?enviar_notificaciones=${shouldSendNotifications}`, formData);
        updateProgress(40);
        
        // Actualizar órdenes editadas
        const totalOrdenes = detallesPedidos.length;
        for (let index = 0; index < detallesPedidos.length; index++) {
          const detalle = detallesPedidos[index];
          if (detalle) {
            const ordenExistente = ordenesGuardadas.find(o => o.secuencia === detalle.SECUENCIA);
            
            if (ordenExistente && (detalleData[`${index}_unidad_medida`] || detalleData[`${index}_caracteristicas`] || detalleData[`${index}_detalles`] || detalleData[`${index}_cant_solicitada`])) {
              const ordenData = {
                ano_eje: detalle.ANO_EJE,
                sec_ejec: detalle.SEC_EJEC,
                tipo_pedido: detalle.TIPO_PEDIDO,
                tipo_bien: detalle.TIPO_BIEN,
                nro_pedido: detalle.NRO_PEDIDO,
                secuencia: detalle.SECUENCIA,
                grupo_bien: detalle.GRUPO_BIEN,
                clase_bien: detalle.CLASE_BIEN,
                familia_bien: detalle.FAMILIA_BIEN,
                item_bien: detalle.ITEM_BIEN,
                cant_solicitada: detalleData[`${index}_cant_solicitada`] || ordenExistente.cant_solicitada || detalle.CANT_SOLICITADA,
                centro_costo: detalle.CENTRO_COSTO,
                nombre_depend: detalle.NOMBRE_DEPEND,
                nombre_item: detalle.NOMBRE_ITEM,
                unidad_medida: detalleData[`${index}_unidad_medida`] || ordenExistente.unidad_medida || 'UN - Unidad',
                caracteristicas: detalleData[`${index}_caracteristicas`] || ordenExistente.caracteristicas || '',
                detalles: detalleData[`${index}_detalles`] || ordenExistente.detalles || '',
                id_convocatoria: editingId
              };
              await api.put(`/api/v1/ordenes/${ordenExistente.id_orden}`, ordenData);
            }
          }
          // Actualizar progreso basado en órdenes procesadas
          updateProgress(40 + Math.floor((index + 1) / totalOrdenes * 30));
        }
        updateProgress(70);
        
        // Subir especificaciones técnicas si hay un archivo seleccionado (en cualquier paso, pero especialmente en paso 5)
        if (especificacionesTecnicasFile && convocatoriaId) {
          try {
            updateProgress(75);
            await handleEspecificacionesTecnicasUpload(convocatoriaId, true); // silent = true para no mostrar notificaciones
            updateProgress(85);
          } catch (error) {
            console.error('Error al subir especificaciones técnicas:', error);
            // No lanzar error para no interrumpir el proceso de guardado
          }
        }
        if (formatosPostulacionFile && convocatoriaId) {
          try {
            await handleFormatosPostulacionUpload(convocatoriaId, true);
          } catch (error) {
            console.error('Error al subir formatos de postulación:', error);
          }
        }
        if (otrosDocumentosFile && convocatoriaId) {
          try {
            await handleOtrosDocumentosUpload(convocatoriaId, true);
          } catch (error) {
            console.error('Error al subir otros documentos:', error);
          }
        }
        
        // Si estamos en modo creación y completamos el paso 5, cambiar a modo edición
        if (isCreating && currentStep === 5) {
          setIsCreating(false);
          setConvocatoriaGuardada(true);
        }
        updateProgress(100);
        
        if (currentStep !== 5) {
        setNotification({
          show: true,
          title: 'Éxito',
          message: 'Convocatoria actualizada exitosamente',
          type: 'success',
          onConfirm: null
        });
        }
      } else {
        // Crear nueva convocatoria
        updateProgress(20);
        // Solo enviar notificaciones si estamos en el paso 5
        const shouldSendNotifications = currentStep === 5;
        const response = await api.post(`/api/v1/convocatorias/?enviar_notificaciones=${shouldSendNotifications}`, formData);
        convocatoriaId = response.data.nro_convocatoria;
        setEditingId(convocatoriaId);
        updateProgress(40);
        
        // Guardar TODAS las órdenes
        const totalOrdenes = detallesPedidos.length;
        for (let index = 0; index < detallesPedidos.length; index++) {
          const detalle = detallesPedidos[index];
          if (detalle) {
            await guardarOrdenBD(detalle, index, convocatoriaId);
          }
          // Actualizar progreso basado en órdenes guardadas
          updateProgress(40 + Math.floor((index + 1) / totalOrdenes * 30));
        }
        updateProgress(70);
        
        // Cargar la convocatoria actualizada para tener acceso a los archivos
        const updatedConvResponse = await api.get(`/api/v1/convocatorias/${convocatoriaId}`);
        setCurrentConvocatoria(updatedConvResponse.data);
        updateProgress(75);
        
        // Subir especificaciones técnicas si hay un archivo seleccionado (en cualquier paso, pero especialmente en paso 5)
        if (especificacionesTecnicasFile) {
          try {
            updateProgress(80);
            await handleEspecificacionesTecnicasUpload(convocatoriaId, true); // silent = true para no mostrar notificaciones
            updateProgress(90);
          } catch (error) {
            console.error('Error al subir especificaciones técnicas:', error);
            // No lanzar error para no interrumpir el proceso de guardado
          }
        }
        if (formatosPostulacionFile) {
          try {
            await handleFormatosPostulacionUpload(convocatoriaId, true);
          } catch (error) {
            console.error('Error al subir formatos de postulación:', error);
          }
        }
        if (otrosDocumentosFile) {
          try {
            await handleOtrosDocumentosUpload(convocatoriaId, true);
          } catch (error) {
            console.error('Error al subir otros documentos:', error);
          }
        }
        
        // Si estamos en el paso 5, cambiar a modo edición después de guardar
        if (currentStep === 5) {
          setIsCreating(false);
          setConvocatoriaGuardada(true);
        }
        updateProgress(100);
        
        if (currentStep !== 5) {
        setNotification({
          show: true,
          title: 'Éxito',
          message: 'Convocatoria creada exitosamente',
          type: 'success',
          onConfirm: () => {
            resetForm();
            setShowForm(false);
          }
        });
        }
      }
      
      // Recargar órdenes guardadas
      if (convocatoriaId) {
        await loadOrdenesGuardadas(convocatoriaId);
      }
      
      loadConvocatorias();
    } catch (error) {
      console.error('Error creating convocatoria:', error);
      setSaveProgress(0);
      setConvocatoriaGuardada(false); // Asegurar que no se muestre el mensaje de éxito si hay error
      setNotification({
        show: true,
        title: 'Error',
        message: formatApiErrorDetail(error, 'Error al crear convocatoria'),
        type: 'error',
        onConfirm: null
      });
    } finally {
      setLoading(false);
      // Resetear progreso después de un breve delay solo si no se guardó exitosamente
      if (!convocatoriaGuardada) {
        setTimeout(() => {
          setSaveProgress(0);
        }, 1000);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      ano_eje: null,
      sec_ejec: null,
      nombre_ejecutora: '',
      tipo_bien: '',
      tipo_pedido: '',
      nro_pedido: '',
      centro_costo: '',
      nombre_depend: '',
      fecha_pedido: '',
      motivo_pedido: '',
      rubro: 'GENERAL',
      concepto: 'S/N',
      estado: 'ABIERTA',
      fecha_inicio: '',
      fecha_fin: '',
      usuario: user?.id_usuario || null
    });
    setSelectedPedido(null);
    setPedidos([]);
    setEditingId(null);
    setDetallesPedidos([]);
    setEditingDetalle(null);
    setDetalleData({});
    setOrdenesGuardadas([]);
    setEditingOrdenId(null);
    setOrdenEditData({});
    setEspecificacionesTecnicasFile(null);
    setCurrentConvocatoria(null);
    setCurrentStep(1); // Resetear al paso 1
    setIsCreating(true); // Establecer en modo creación
    setConvocatoriaGuardada(false); // Resetear estado de guardado
    setSaveProgress(0); // Resetear progreso de guardado
    setUploadProgress(0); // Resetear progreso de carga
  };

  // Validar paso actual
  const validateStep = (step) => {
    switch(step) {
      case 1:
        return selectedPedido !== null;
      case 2:
        return formData.rubro && formData.concepto && formData.estado && formData.fecha_inicio && formData.fecha_fin;
      case 3:
        return detallesPedidos.length > 0;
      case 4:
        return true; // Paso de documentos, opcional
      case 5:
        return true; // Paso de revisión, siempre válido
      default:
        return false;
    }
  };

  // Navegar al siguiente paso
  const nextStep = () => {
    if (validateStep(currentStep)) {
      if (currentStep < 5) {
        setCurrentStep(currentStep + 1);
      }
    } else {
      let message = 'Por favor complete todos los campos requeridos antes de continuar.';
      if (currentStep === 2) {
        const missingFields = [];
        if (!formData.rubro) missingFields.push('Rubro');
        if (!formData.concepto) missingFields.push('Concepto');
        if (!formData.estado) missingFields.push('Estado');
        if (!formData.fecha_inicio) missingFields.push('Fecha Inicio');
        if (!formData.fecha_fin) missingFields.push('Fecha Fin');
        if (missingFields.length > 0) {
          message = `Por favor complete los siguientes campos requeridos: ${missingFields.join(', ')}`;
        }
      }
      setNotification({
        show: true,
        title: 'Paso incompleto',
        message: message,
        type: 'warning',
        onConfirm: null
      });
    }
  };

  // Navegar al paso anterior
  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  // Ir a un paso específico
  const goToStep = (step) => {
    if (step >= 1 && step <= 5) {
      setCurrentStep(step);
    }
  };

  const loadOrdenesGuardadas = async (convocatoriaId) => {
    if (!convocatoriaId) return;
    try {
      const response = await api.get(`/api/v1/ordenes/convocatoria/${convocatoriaId}`);
      const ordenes = response.data || [];
      setOrdenesGuardadas(ordenes);
      
      // Cargar los datos editados en detalleData
      if (detallesPedidos.length > 0) {
        const secuenciasGuardadas = new Set(ordenes.map(o => o.secuencia));
        const nuevosDatos = { ...detalleData };
        
        detallesPedidos.forEach((detalle, index) => {
          if (secuenciasGuardadas.has(detalle.SECUENCIA)) {
            // Encontrar la orden correspondiente a esta secuencia
            const orden = ordenes.find(o => o.secuencia === detalle.SECUENCIA);
            if (orden) {
              // Cargar los datos de la orden en detalleData
              nuevosDatos[`${index}_unidad_medida`] = orden.unidad_medida || 'UN - Unidad';
              nuevosDatos[`${index}_caracteristicas`] = orden.caracteristicas || '';
              nuevosDatos[`${index}_detalles`] = orden.detalles || '';
              nuevosDatos[`${index}_cant_solicitada`] = orden.cant_solicitada || '';
            }
          }
        });
        
        setDetalleData(nuevosDatos);
      }
    } catch (error) {
      console.error('Error loading ordenes:', error);
      setOrdenesGuardadas([]);
    }
  };

  const guardarOrdenBD = async (detalle, index, convocatoriaId) => {
    const ordenData = {
      ano_eje: detalle.ANO_EJE,
      sec_ejec: detalle.SEC_EJEC,
      tipo_pedido: detalle.TIPO_PEDIDO,
      tipo_bien: detalle.TIPO_BIEN,
      nro_pedido: detalle.NRO_PEDIDO,
      secuencia: detalle.SECUENCIA,
      grupo_bien: detalle.GRUPO_BIEN,
      clase_bien: detalle.CLASE_BIEN,
      familia_bien: detalle.FAMILIA_BIEN,
      item_bien: detalle.ITEM_BIEN,
      cant_solicitada: detalleData[`${index}_cant_solicitada`] || detalle.CANT_SOLICITADA,
      centro_costo: detalle.CENTRO_COSTO,
      nombre_depend: detalle.NOMBRE_DEPEND,
      nombre_item: detalle.NOMBRE_ITEM,
      unidad_medida: detalleData[`${index}_unidad_medida`] || detalle.unidad_medida || 'UN - Unidad',
      caracteristicas: detalleData[`${index}_caracteristicas`] || detalle.caracteristicas || '',
      detalles: detalleData[`${index}_detalles`] || detalle.detalles || '',
      id_convocatoria: convocatoriaId
    };

    return await api.post('/api/v1/ordenes/', ordenData);
  };

  const handleEliminarOrden = async (ordenId) => {
    setNotification({
      show: true,
      title: 'Confirmar eliminación',
      message: '¿Está seguro de que desea eliminar esta orden?',
      type: 'confirm',
      onConfirm: async () => {
        try {
          await api.delete(`/api/v1/ordenes/${ordenId}`);
          setNotification({
            show: true,
            title: 'Éxito',
            message: 'Orden eliminada exitosamente',
            type: 'success',
            onConfirm: null
          });
          await loadOrdenesGuardadas(editingId);
        } catch (error) {
          console.error('Error eliminando orden:', error);
          setNotification({
            show: true,
            title: 'Error',
            message: formatApiErrorDetail(error, 'Error al eliminar la orden'),
            type: 'error',
            onConfirm: null
          });
        }
      },
      showCancel: true
    });
  };

  const handleView = async (id) => {
    try {
      const response = await api.get(`/api/v1/convocatorias/${id}`);
      const conv = response.data;
      
      // Cargar las órdenes asociadas
      const ordenesResponse = await api.get(`/api/v1/ordenes/convocatoria/${id}`);
      const ordenes = ordenesResponse.data || [];
      
      setDetalleConvocatoria(conv);
      setDetalleOrdenes(ordenes);
      setShowDetails(true);
    } catch (error) {
      console.error('Error loading convocatoria:', error);
      setNotification({
        show: true,
        title: 'Error',
        message: 'Error al cargar los detalles de la convocatoria',
        type: 'error',
        onConfirm: null
      });
    }
  };

  // Función auxiliar para formatear fecha para input type="date"
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    try {
      // Si ya está en formato YYYY-MM-DD, retornarlo
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return dateString;
      }
      // Si viene en formato ISO o con hora, extraer solo la fecha
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error('Error formateando fecha:', error);
      return '';
    }
  };

  // Formato para input type="datetime-local" (YYYY-MM-DDTHH:mm)
  const formatDateTimeLocalForInput = (dateString) => {
    if (!dateString) return '';
    try {
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(dateString)) {
        return dateString;
      }
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    } catch (error) {
      console.error('Error formateando fecha/hora:', error);
      return '';
    }
  };

  const handleEdit = async (convocatoria) => {
    // Si convocatoria es un objeto directo, usarlo; si no, obtenerlo de la API
    let convData = convocatoria;
    if (typeof convocatoria === 'object' && !convocatoria.nro_convocatoria) {
      // Es una promesa, esperarla
      convData = await convocatoria;
    }

    if (convData?.orden_notificada) {
      setNotification({
        show: true,
        title: 'Edición no disponible',
        message:
          'Esta convocatoria ya tiene una orden notificada al proveedor. No se puede editar.',
        type: 'warning',
        onConfirm: null,
      });
      return;
    }

    // Cargar datos de la convocatoria en el formulario
    setFormData({
      ano_eje: convData.ano_eje,
      sec_ejec: convData.sec_ejec,
      nombre_ejecutora: convData.nombre_ejecutora || '',
      tipo_bien: convData.tipo_bien || '',
      tipo_pedido: convData.tipo_pedido || '',
      nro_pedido: convData.nro_pedido || '',
      centro_costo: convData.centro_costo || '',
      nombre_depend: convData.nombre_depend || '',
      fecha_pedido: formatDateForInput(convData.fecha_pedido),
      motivo_pedido: convData.motivo_pedido || '',
      rubro: convData.rubro || '',
      concepto: convData.concepto || '',
      estado: convData.estado || 'ABIERTA',
      fecha_inicio: formatDateForInput(convData.fecha_inicio),
      fecha_fin: formatDateTimeLocalForInput(convData.fecha_fin),
      usuario: user?.id_usuario || null
    });
    setEditingId(convData.nro_convocatoria);
    setCurrentConvocatoria(convData);
    setShowForm(true);
    setIsCreating(false); // Establecer en modo edición
    setConvocatoriaGuardada(false); // Resetear estado de guardado
    setCurrentStep(1); // Resetear al paso 1 para edición
    
    // Buscar detalles del pedido si existe
    if (convData.ano_eje && convData.sec_ejec && convData.tipo_pedido && convData.tipo_bien && convData.nro_pedido) {
      loadDetallesPedidos({
        ANO_EJE: convData.ano_eje,
        SEC_EJEC: convData.sec_ejec,
        TIPO_PEDIDO: convData.tipo_pedido,
        TIPO_BIEN: convData.tipo_bien,
        NRO_PEDIDO: convData.nro_pedido
      });
    }
    
    // Cargar órdenes guardadas
    loadOrdenesGuardadas(convData.nro_convocatoria);
  };

  const handleDelete = async (id) => {
    setNotification({
      show: true,
      title: 'Confirmar eliminación',
      message: '¿Está seguro de que desea eliminar esta convocatoria?',
      type: 'confirm',
      onConfirm: async () => {
        try {
          await api.delete(`/api/v1/convocatorias/${id}`);
          setNotification({
            show: true,
            title: 'Éxito',
            message: 'Convocatoria eliminada exitosamente',
            type: 'success',
            onConfirm: null
          });
          loadConvocatorias();
        } catch (error) {
          console.error('Error deleting convocatoria:', error);
          setNotification({
            show: true,
            title: 'Error',
            message: formatApiErrorDetail(error, 'Error al eliminar convocatoria'),
            type: 'error',
            onConfirm: null
          });
        }
      },
      showCancel: true
    });
  };

  const handleEspecificacionesTecnicasUpload = async (convocatoriaId, silent = false) => {
    if (!especificacionesTecnicasFile) {
      if (!silent) {
        setNotification({
          show: true,
          title: 'Archivo requerido',
          message: 'Por favor seleccione un archivo PDF',
          type: 'warning',
          onConfirm: null
        });
      }
      return;
    }

    if (!especificacionesTecnicasFile.name.toLowerCase().endsWith('.pdf')) {
      if (!silent) {
        setNotification({
          show: true,
          title: 'Formato incorrecto',
          message: 'El archivo debe ser un PDF',
          type: 'warning',
          onConfirm: null
        });
      }
      return;
    }

    setUploadingEspecificaciones(true);
    setUploadProgress(0);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('especificaciones_tecnicas_pdf', especificacionesTecnicasFile);

      await api.put(`/api/v1/convocatorias/${convocatoriaId}/especificaciones-tecnicas`, formDataToSend, {
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percentCompleted);
          }
        },
      });

      setUploadProgress(100);
      if (!silent) {
        setNotification({
          show: true,
          title: 'Éxito',
          message: 'Especificaciones técnicas subidas exitosamente',
          type: 'success',
          onConfirm: null
        });
      }
      setEspecificacionesTecnicasFile(null);
      // Resetear progreso después de un breve delay
      setTimeout(() => {
        setUploadProgress(0);
      }, 1000);
      
      // Recargar la convocatoria actualizada
      const updatedResponse = await api.get(`/api/v1/convocatorias/${convocatoriaId}`);
      setCurrentConvocatoria(updatedResponse.data);
      loadConvocatorias();
      
      // Si estamos en el paso 4, recargar para mostrar el archivo subido
      if (currentStep === 4) {
        const refreshedResponse = await api.get(`/api/v1/convocatorias/${convocatoriaId}`);
        setCurrentConvocatoria(refreshedResponse.data);
      }
    } catch (error) {
      console.error('Error uploading especificaciones:', error);
      setUploadProgress(0);
      if (!silent) {
        setNotification({
          show: true,
          title: 'Error',
          message: formatApiErrorDetail(error, 'Error al subir las especificaciones técnicas'),
          type: 'error',
          onConfirm: null
        });
      }
      throw error; // Re-lanzar el error para que handleSubmit pueda manejarlo
    } finally {
      setUploadingEspecificaciones(false);
    }
  };

  const handleFormatosPostulacionUpload = async (convocatoriaId, silent = false) => {
    if (!formatosPostulacionFile) {
      if (!silent) {
        setNotification({ show: true, title: 'Archivo requerido', message: 'Seleccione un PDF de formatos de postulación', type: 'warning', onConfirm: null });
      }
      return;
    }
    if (!formatosPostulacionFile.name.toLowerCase().endsWith('.pdf')) {
      if (!silent) {
        setNotification({ show: true, title: 'Formato incorrecto', message: 'El archivo debe ser un PDF', type: 'warning', onConfirm: null });
      }
      return;
    }
    setUploadingFormatosPostulacion(true);
    try {
      const fd = new FormData();
      fd.append('formatos_postulacion_pdf', formatosPostulacionFile);
      await api.put(`/api/v1/convocatorias/${convocatoriaId}/formatos-postulacion`, fd);
      if (!silent) {
        setNotification({ show: true, title: 'Éxito', message: 'Formatos de postulación subidos correctamente', type: 'success', onConfirm: null });
      }
      setFormatosPostulacionFile(null);
      const updatedResponse = await api.get(`/api/v1/convocatorias/${convocatoriaId}`);
      setCurrentConvocatoria(updatedResponse.data);
      loadConvocatorias();
    } catch (error) {
      if (!silent) {
        setNotification({
          show: true,
          title: 'Error',
          message: formatApiErrorDetail(error, 'Error al subir formatos de postulación'),
          type: 'error',
          onConfirm: null,
        });
      }
      throw error;
    } finally {
      setUploadingFormatosPostulacion(false);
    }
  };

  const handleOtrosDocumentosUpload = async (convocatoriaId, silent = false) => {
    if (!otrosDocumentosFile) {
      if (!silent) {
        setNotification({ show: true, title: 'Archivo requerido', message: 'Seleccione un PDF de otros documentos', type: 'warning', onConfirm: null });
      }
      return;
    }
    if (!otrosDocumentosFile.name.toLowerCase().endsWith('.pdf')) {
      if (!silent) {
        setNotification({ show: true, title: 'Formato incorrecto', message: 'El archivo debe ser un PDF', type: 'warning', onConfirm: null });
      }
      return;
    }
    setUploadingOtrosDocumentos(true);
    try {
      const fd = new FormData();
      fd.append('otros_documentos_pdf', otrosDocumentosFile);
      await api.put(`/api/v1/convocatorias/${convocatoriaId}/otros-documentos`, fd);
      if (!silent) {
        setNotification({ show: true, title: 'Éxito', message: 'Otros documentos subidos correctamente', type: 'success', onConfirm: null });
      }
      setOtrosDocumentosFile(null);
      const updatedResponse = await api.get(`/api/v1/convocatorias/${convocatoriaId}`);
      setCurrentConvocatoria(updatedResponse.data);
      loadConvocatorias();
    } catch (error) {
      if (!silent) {
        setNotification({
          show: true,
          title: 'Error',
          message: formatApiErrorDetail(error, 'Error al subir otros documentos'),
          type: 'error',
          onConfirm: null,
        });
      }
      throw error;
    } finally {
      setUploadingOtrosDocumentos(false);
    }
  };

  const handleGenerarSolicitudCotizacion = async (convocatoriaId) => {
    setGeneratingPDF(true);
    try {
      const response = await api.post(`/api/v1/convocatorias/${convocatoriaId}/generar-solicitud-cotizacion`, {}, {
        responseType: 'blob',
      });

      // Crear un enlace temporal para descargar el PDF
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Solicitud_Cotizacion_${convocatoriaId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setNotification({
        show: true,
        title: 'Éxito',
        message: 'Solicitud de cotización generada y descargada exitosamente',
        type: 'success',
        onConfirm: null
      });
      
      // Recargar la convocatoria actualizada
      const updatedResponse = await api.get(`/api/v1/convocatorias/${convocatoriaId}`);
      setCurrentConvocatoria(updatedResponse.data);
      loadConvocatorias();
      
      // Si estamos en el paso 4, avanzar automáticamente al paso 5
      if (currentStep === 4) {
        setCurrentStep(5);
      }
    } catch (error) {
      console.error('Error generating PDF:', error);
      setNotification({
        show: true,
        title: 'Error',
        message: formatApiErrorDetail(error, 'Error al generar la solicitud de cotización'),
        type: 'error',
        onConfirm: null
      });
    } finally {
      setGeneratingPDF(false);
    }
  };

  return (
    <div>
      <style>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .shimmer-animation {
          animation: shimmer 1.5s infinite;
        }
      `}</style>
      <div className="d-flex justify-content-between align-items-center mb-4" style={{ 
        padding: '1.5rem', 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
        borderRadius: '10px',
        color: 'white',
        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
      }}>
        <div>
          <h1 className="h3 mb-1 fw-bold" style={{ color: 'white', margin: 0 }}>
            <i className="bi bi-file-earmark-text me-2"></i>
            Convocatorias
          </h1>
          <p className="mb-0" style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem' }}>
            Gestión y administración de convocatorias del sistema
          </p>
        </div>
        <button 
          onClick={() => {
            if (showForm) {
              // Si el formulario está abierto, cerrarlo
              setShowForm(false);
            } else {
              // Si el formulario está cerrado, abrirlo y resetear
              resetForm();
              setShowForm(true);
            }
          }} 
          className={`btn ${showForm ? 'btn-light' : 'btn-light'}`}
          style={{
            fontWeight: '600',
            padding: '0.75rem 1.5rem',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            if (!showForm) e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
          }}
        >
          <i className={`bi ${showForm ? 'bi-x-circle' : 'bi-plus-circle'} me-2`}></i>
          {showForm ? 'Cancelar' : 'Nueva Convocatoria'}
        </button>
      </div>

      {showForm && (
        <div style={{ background: 'white', padding: '2rem', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginBottom: '2rem' }}>
          <h2>{convocatoriaGuardada ? 'Convocatoria Guardada' : (isCreating ? 'Nueva Convocatoria' : 'Editar Convocatoria')}</h2>
          
          {/* Sistema de Pasos (Wizard) - Solo para nuevas convocatorias o durante creación, o cuando se acaba de guardar */}
          {(isCreating || convocatoriaGuardada) && (
            <>
              {/* Indicador de Pasos - Solo mostrar si no se ha guardado aún */}
              {!convocatoriaGuardada && (
              <div style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f8f9fa', borderRadius: '10px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
                  {[1, 2, 3, 4, 5].map((step) => {
                    const isActive = currentStep === step;
                    const isCompleted = currentStep > step;
                    const isValid = validateStep(step);
                    
                    return (
                      <div key={step} style={{ display: 'contents' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, position: 'relative', zIndex: 2 }}>
                          <div
                            onClick={() => goToStep(step)}
                            style={{
                              width: '50px',
                              height: '50px',
                              borderRadius: '50%',
                              background: isCompleted ? '#28a745' : isActive ? '#667eea' : '#dee2e6',
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold',
                              fontSize: '1.2rem',
                              cursor: 'pointer',
                              transition: 'all 0.3s',
                              border: isActive ? '3px solid #667eea' : '3px solid transparent',
                              boxShadow: isActive ? '0 0 0 4px rgba(102, 126, 234, 0.2)' : 'none'
                            }}
                          >
                            {isCompleted ? '✓' : step}
                          </div>
                          <div style={{ marginTop: '0.5rem', textAlign: 'center', fontSize: '0.85rem', fontWeight: isActive ? '600' : '400', color: isActive ? '#667eea' : '#6c757d' }}>
                            {step === 1 && 'Buscar Pedido'}
                            {step === 2 && 'Información'}
                            {step === 3 && 'Detalles'}
                            {step === 4 && 'Documentos'}
                            {step === 5 && 'Revisar'}
                          </div>
                          {!isValid && step < currentStep && (
                            <div style={{ marginTop: '0.25rem', fontSize: '0.75rem', color: '#dc3545' }}>
                              <i className="bi bi-exclamation-circle"></i> Incompleto
                            </div>
                          )}
                        </div>
                        {step < 5 && (
                          <div style={{
                            flex: 1,
                            height: '3px',
                            background: currentStep > step ? '#28a745' : '#dee2e6',
                            margin: '0 1rem',
                            marginTop: '-25px',
                            position: 'relative',
                            zIndex: 1
                          }} />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              )}

              {/* Contenido del Paso Actual */}
              <div style={{ minHeight: '400px' }}>
                {/* Paso 1: Buscar Pedido en SIGA */}
                {currentStep === 1 && (
                  <div style={{ padding: '1.5rem', background: '#f8f9fa', borderRadius: '10px', border: '1px solid #dee2e6' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                      <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#667eea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '1rem', fontSize: '1.2rem' }}>
                        <i className="bi bi-search"></i>
                      </div>
                      <div>
                        <h3 style={{ margin: 0, color: '#2c3e50' }}>Paso 1: Buscar Pedido en SIGA</h3>
                        <p style={{ margin: '0.25rem 0 0 0', color: '#6c757d', fontSize: '0.9rem' }}>
                          Busque y seleccione el pedido de SIGA que desea convertir en convocatoria
                        </p>
                      </div>
                    </div>
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
              <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
                          <i className="bi bi-hash me-2"></i>Número de Pedido:
                        </label>
                <input
                  type="text"
                  value={searchNroPedido}
                  onChange={(e) => setSearchNroPedido(e.target.value)}
                          placeholder="Ej: 001680"
                          style={{ width: '100%', padding: '0.75rem', border: '2px solid #dee2e6', borderRadius: '8px', fontSize: '1rem' }}
                />
              </div>
              <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
                          <i className="bi bi-calendar me-2"></i>Año:
                        </label>
                <input
                  type="number"
                  value={searchAnoEje}
                  onChange={(e) => setSearchAnoEje(e.target.value)}
                          style={{ width: '100%', padding: '0.75rem', border: '2px solid #dee2e6', borderRadius: '8px', fontSize: '1rem' }}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button 
                          type="button" 
                          onClick={searchPedidos} 
                          disabled={loading || !searchNroPedido || !searchAnoEje}
                          style={{ 
                            padding: '0.75rem 2rem', 
                            background: loading || !searchNroPedido || !searchAnoEje ? '#ccc' : '#48bb78', 
                            color: 'white', 
                            border: 'none', 
                            borderRadius: '8px', 
                            cursor: loading || !searchNroPedido || !searchAnoEje ? 'not-allowed' : 'pointer',
                            fontWeight: '600',
                            fontSize: '1rem',
                            transition: 'all 0.3s'
                          }}
                        >
                          {loading ? (
                            <>
                              <i className="bi bi-hourglass-split me-2"></i>Buscando...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-search me-2"></i>Buscar
                            </>
                          )}
                </button>
              </div>
            </div>

            {/* Resultados de búsqueda */}
            {!loading && pedidos.length === 0 && searchNroPedido && searchAnoEje && (
              <div style={{ marginTop: '1rem', padding: '1rem', background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '5px', textAlign: 'center' }}>
                No se encontraron pedidos con los criterios de búsqueda ingresados.
              </div>
            )}
            {pedidos.length > 0 && (
              <div style={{ marginTop: '1rem' }}>
                <h4>Resultados encontrados: {pedidos.length}</h4>
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  {pedidos.map((pedido, index) => (
                    <div
                      key={index}
                      onClick={() => selectPedido(pedido)}
                      style={{
                        padding: '1rem',
                        marginBottom: '1rem',
                        background: selectedPedido === pedido ? '#e6f3ff' : 'white',
                        border: selectedPedido === pedido ? '2px solid #667eea' : '1px solid #ddd',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        if (selectedPedido !== pedido) e.target.style.background = '#f9f9f9';
                      }}
                      onMouseLeave={(e) => {
                        if (selectedPedido !== pedido) e.target.style.background = 'white';
                      }}
                    >
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
                        <div>
                          <strong>NRO_PEDIDO:</strong> {pedido.NRO_PEDIDO}
                        </div>
                        <div>
                          <strong>ANO_EJE:</strong> {pedido.ANO_EJE}
                        </div>
                        <div>
                          <strong>SEC_EJEC:</strong> {pedido.SEC_EJEC}
                        </div>
                        <div>
                          <strong>Ejecutora:</strong> {pedido.nombre_ejecutora}
                        </div>
                        <div>
                          <strong>TIPO_BIEN:</strong> {pedido.TIPO_BIEN}
                        </div>
                        <div>
                          <strong>TIPO_PEDIDO:</strong> {pedido.TIPO_PEDIDO}
                        </div>
                        <div>
                          <strong>CENTRO_COSTO:</strong> {pedido.CENTRO_COSTO}
                        </div>
                        <div>
                          <strong>Dependencia:</strong> {pedido.NOMBRE_DEPEND}
                        </div>
                        <div>
                          <strong>FECHA_PEDIDO:</strong> {pedido.FECHA_PEDIDO ? new Date(pedido.FECHA_PEDIDO).toLocaleDateString() : 'N/A'}
                        </div>
                        <div style={{ gridColumn: 'span 2' }}>
                          <strong>MOTIVO_PEDIDO:</strong> {pedido.MOTIVO_PEDIDO ? (pedido.MOTIVO_PEDIDO.length > 100 ? pedido.MOTIVO_PEDIDO.substring(0, 100) + '...' : pedido.MOTIVO_PEDIDO) : 'N/A'}
                        </div>
                      </div>
                      <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            selectPedido(pedido);
                          }}
                          style={{
                            flex: 1,
                            padding: '0.75rem',
                            background: selectedPedido === pedido ? '#48bb78' : '#667eea',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            transition: 'background 0.2s'
                          }}
                        >
                          {selectedPedido === pedido ? '✓ Seleccionado' : 'Seleccionar Pedido'}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          )}

                {/* Paso 2: Información de la Convocatoria */}
              {currentStep === 2 && (
                <div style={{ padding: '1.5rem', background: '#f8f9fa', borderRadius: '10px', border: '1px solid #dee2e6' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#667eea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '1rem', fontSize: '1.2rem' }}>
                      <i className="bi bi-info-circle"></i>
                    </div>
                    <div>
                      <h3 style={{ margin: 0, color: '#2c3e50' }}>Paso 2: Información de la Convocatoria</h3>
                      <p style={{ margin: '0.25rem 0 0 0', color: '#6c757d', fontSize: '0.9rem' }}>
                        Complete la información básica de la convocatoria
                      </p>
                    </div>
                  </div>

                  {selectedPedido && (
                    <div style={{ marginBottom: '1.5rem', padding: '1rem', background: '#d4edda', borderRadius: '8px', border: '1px solid #c3e6cb' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                        <i className="bi bi-check-circle-fill" style={{ color: '#28a745', marginRight: '0.5rem', fontSize: '1.2rem' }}></i>
                        <strong style={{ color: '#155724' }}>Pedido seleccionado: {selectedPedido.NRO_PEDIDO} - {selectedPedido.nombre_ejecutora}</strong>
                      </div>
                      <button 
                        type="button" 
                        onClick={() => setCurrentStep(1)}
                        style={{ 
                          padding: '0.25rem 0.75rem', 
                          background: 'transparent', 
                          border: '1px solid #28a745', 
                          color: '#28a745', 
                          borderRadius: '5px',
                          cursor: 'pointer',
                          fontSize: '0.85rem'
                        }}
                      >
                        Cambiar pedido
                      </button>
                    </div>
                  )}

                  <form onSubmit={(e) => { e.preventDefault(); nextStep(); }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                      <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
                          Rubro <span style={{ color: '#dc3545' }}>*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.rubro}
                          onChange={(e) => setFormData({ ...formData, rubro: e.target.value })}
                          required
                          placeholder="Ej: GENERAL"
                          style={{ width: '100%', padding: '0.75rem', border: formData.rubro ? '2px solid #28a745' : '2px solid #dee2e6', borderRadius: '8px', fontSize: '1rem' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
                          Concepto <span style={{ color: '#dc3545' }}>*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.concepto}
                          onChange={(e) => setFormData({ ...formData, concepto: e.target.value })}
                          required
                          placeholder="Ej: S/N"
                          style={{ width: '100%', padding: '0.75rem', border: formData.concepto ? '2px solid #28a745' : '2px solid #dee2e6', borderRadius: '8px', fontSize: '1rem' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
                          Estado <span style={{ color: '#dc3545' }}>*</span>
                        </label>
                        <select
                          value={formData.estado}
                          onChange={(e) => setFormData({ ...formData, estado: e.target.value })}
                          required
                          style={{ width: '100%', padding: '0.75rem', border: '2px solid #dee2e6', borderRadius: '8px', fontSize: '1rem' }}
                        >
                          <option value="ABIERTA">ABIERTA</option>
                          <option value="CERRADA">CERRADA</option>
                          <option value="EVALUACION">EVALUACION</option>
                          <option value="FINALIZADA">FINALIZADA</option>
                        </select>
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
                          Fecha Inicio <span style={{ color: '#dc3545' }}>*</span>
                        </label>
                        <input
                          type="date"
                          value={formData.fecha_inicio}
                          onChange={(e) => setFormData({ ...formData, fecha_inicio: e.target.value })}
                          required
                          min={new Date().toISOString().split('T')[0]}
                          style={{ 
                            width: '100%', 
                            padding: '0.75rem', 
                            border: formData.fecha_inicio ? '2px solid #28a745' : '2px solid #dee2e6', 
                            borderRadius: '8px', 
                            fontSize: '1rem' 
                          }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
                          Fecha y hora de cierre <span style={{ color: '#dc3545' }}>*</span>
                        </label>
                        <input
                          type="datetime-local"
                          value={formData.fecha_fin}
                          onChange={(e) => setFormData({ ...formData, fecha_fin: e.target.value })}
                          required
                          min={
                            formData.fecha_inicio
                              ? `${formData.fecha_inicio}T00:00`
                              : new Date().toISOString().slice(0, 16)
                          }
                          style={{ 
                            width: '100%', 
                            padding: '0.75rem', 
                            border: formData.fecha_fin ? '2px solid #28a745' : '2px solid #dee2e6', 
                            borderRadius: '8px', 
                            fontSize: '1rem' 
                          }}
                        />
                        {formData.fecha_inicio && formData.fecha_fin && new Date(formData.fecha_fin) < new Date(formData.fecha_inicio) && (
                          <small style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem', display: 'block' }}>
                            <i className="bi bi-exclamation-triangle me-1"></i>
                            La fecha fin debe ser posterior a la fecha inicio
                          </small>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              )}

              {/* Paso 3: Detalles del Pedido */}
              {currentStep === 3 && (
                <div style={{ padding: '1.5rem', background: '#f8f9fa', borderRadius: '10px', border: '1px solid #dee2e6' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#667eea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '1rem', fontSize: '1.2rem' }}>
                      <i className="bi bi-list-ul"></i>
                    </div>
                    <div>
                      <h3 style={{ margin: 0, color: '#2c3e50' }}>Paso 3: Detalles del Pedido</h3>
                      <p style={{ margin: '0.25rem 0 0 0', color: '#6c757d', fontSize: '0.9rem' }}>
                        Revise y edite los detalles de los items del pedido (opcional)
                      </p>
                    </div>
                  </div>
                  {selectedPedido && formData.ano_eje && (
                    <div style={{ marginTop: '2rem' }}>
                      {loadingDetalles ? (
                        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                          <i className="bi bi-hourglass-split" style={{ fontSize: '2rem', marginBottom: '1rem' }}></i>
                          <p>Cargando detalles...</p>
                        </div>
                      ) : detallesPedidos.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '2rem', color: '#666', background: 'white', borderRadius: '8px' }}>
                          <i className="bi bi-inbox" style={{ fontSize: '2rem', marginBottom: '1rem', color: '#ccc' }}></i>
                          <p>No se encontraron detalles para este pedido.</p>
                        </div>
                      ) : (
                        <div style={{ background: 'white', padding: '1rem', borderRadius: '8px' }}>
                          <p style={{ marginBottom: '1rem', color: '#6c757d', fontSize: '0.9rem' }}>
                            <i className="bi bi-info-circle me-2"></i>
                            Se encontraron <strong>{detallesPedidos.length}</strong> item(s). Puede editar las cantidades, unidades de medida y características antes de continuar.
                          </p>
                          <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                              <thead>
                                <tr style={{ background: '#667eea', color: 'white' }}>
                                  <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Secuencia</th>
                                  <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Item</th>
                                  <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Nombre Item</th>
                                  <th style={{ padding: '0.75rem', textAlign: 'right', border: '1px solid #ddd' }}>Cantidad</th>
                                  <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Unidad</th>
                                  <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Características</th>
                                  <th style={{ padding: '0.75rem', textAlign: 'center', border: '1px solid #ddd' }}>Acciones</th>
                                </tr>
                              </thead>
                              <tbody>
                                {detallesPedidos.map((detalle, index) => (
                                  <tr key={index} style={{ borderBottom: '1px solid #e2e8f0' }}>
                                    <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{detalle.SECUENCIA}</td>
                                    <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>
                                      {detalle.GRUPO_BIEN}-{detalle.CLASE_BIEN}-{detalle.FAMILIA_BIEN}-{detalle.ITEM_BIEN}
                                    </td>
                                    <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{detalle.NOMBRE_ITEM || 'N/A'}</td>
                                    <td style={{ padding: '0.75rem', textAlign: 'right', border: '1px solid #ddd' }}>
                                      {editingDetalle === index ? (
                                        <input
                                          type="number"
                                          value={detalleData[`${index}_cant_solicitada`] || detalle.CANT_SOLICITADA || ''}
                                          onChange={(e) => setDetalleData({...detalleData, [`${index}_cant_solicitada`]: e.target.value})}
                                          style={{ width: '80px', padding: '0.5rem', border: '1px solid #ccc', borderRadius: '3px', textAlign: 'right' }}
                                          min="0"
                                          step="0.01"
                                        />
                                      ) : (
                                        Math.round(Number(detalleData[`${index}_cant_solicitada`] || detalle.CANT_SOLICITADA || 0))
                                      )}
                                    </td>
                                    <td style={{ padding: '0.5rem', border: '1px solid #ddd' }}>
                                      {editingDetalle === index ? (
                                        <select
                                          value={detalleData[`${index}_unidad_medida`] || detalle.unidad_medida || 'UN - Unidad'}
                                          onChange={(e) => setDetalleData({...detalleData, [`${index}_unidad_medida`]: e.target.value})}
                                          style={{ width: '100%', padding: '0.5rem', border: '1px solid #ccc', borderRadius: '3px', fontSize: '0.875rem' }}
                                        >
                                          {unidadesMedida.map(um => (
                                            <option key={um.value} value={um.label}>{um.label}</option>
                                          ))}
                                        </select>
                                      ) : (
                                        detalleData[`${index}_unidad_medida`] || detalle.unidad_medida || 'UN - Unidad'
                                      )}
                                    </td>
                                    <td style={{ padding: '0.5rem', border: '1px solid #ddd' }}>
                                      {editingDetalle === index ? (
                                        <input
                                          type="text"
                                          value={detalleData[`${index}_caracteristicas`] || detalle.caracteristicas || ''}
                                          onChange={(e) => setDetalleData({...detalleData, [`${index}_caracteristicas`]: e.target.value})}
                                          style={{ width: '100%', padding: '0.25rem', border: '1px solid #ccc', borderRadius: '3px' }}
                                          placeholder="Características"
                                        />
                                      ) : (
                                        detalleData[`${index}_caracteristicas`] || detalle.caracteristicas || '-'
                                      )}
                                    </td>
                                    <td style={{ padding: '0.75rem', textAlign: 'center', border: '1px solid #ddd' }}>
                                      {editingDetalle === index ? (
                                        <button
                                          type="button"
                                          onClick={() => setEditingDetalle(null)}
                                          style={{
                                            padding: '0.5rem 1rem',
                                            background: '#48bb78',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            fontSize: '0.875rem'
                                          }}
                                        >
                                          ✓ Listo
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          onClick={() => setEditingDetalle(index)}
                                          style={{
                                            padding: '0.5rem 1rem',
                                            background: '#4299e1',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            fontSize: '0.875rem'
                                          }}
                                        >
                                          ✎ Editar
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Paso 4: Documentos (Especificaciones Técnicas y Generar PDF) */}
              {currentStep === 4 && (
                <div style={{ padding: '1.5rem', background: '#f8f9fa', borderRadius: '10px', border: '1px solid #dee2e6' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#667eea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '1rem', fontSize: '1.2rem' }}>
                      <i className="bi bi-file-earmark-pdf"></i>
                    </div>
                    <div>
                      <h3 style={{ margin: 0, color: '#2c3e50' }}>Paso 4: Documentos</h3>
                      <p style={{ margin: '0.25rem 0 0 0', color: '#6c757d', fontSize: '0.9rem' }}>
                        Cargue las especificaciones técnicas y genere el PDF de solicitud de cotización (opcional)
                      </p>
                    </div>
                  </div>

                  {/* Sección de Especificaciones Técnicas */}
                  <div style={{ marginBottom: '2rem', padding: '1.5rem', background: 'white', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                    <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#2c3e50', display: 'flex', alignItems: 'center' }}>
                      <i className="bi bi-file-earmark-text me-2" style={{ color: '#667eea' }}></i>
                      Especificaciones Técnicas
                    </h4>
                    <p style={{ marginBottom: '1rem', color: '#6c757d', fontSize: '0.9rem' }}>
                      Suba un archivo PDF con las especificaciones técnicas de la convocatoria. Este documento será visible para los proveedores.
                    </p>
                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-end' }}>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
                          Seleccionar archivo PDF:
                        </label>
                        <input
                          type="file"
                          accept=".pdf"
                          onChange={(e) => setEspecificacionesTecnicasFile(e.target.files[0])}
                          style={{ width: '100%', padding: '0.75rem', border: '2px solid #dee2e6', borderRadius: '8px', fontSize: '1rem' }}
                        />
                        {especificacionesTecnicasFile && (
                          <div style={{ marginTop: '0.5rem', padding: '0.75rem', background: '#d4edda', borderRadius: '5px', border: '1px solid #c3e6cb' }}>
                            <p style={{ margin: 0, color: '#155724', fontSize: '0.9rem' }}>
                              <i className="bi bi-check-circle-fill me-2"></i>
                              Archivo seleccionado: <strong>{especificacionesTecnicasFile.name}</strong>
                            </p>
                          </div>
                        )}
                      </div>
                      <button
                        type="button"
                        onClick={async () => {
                          // Primero necesitamos guardar la convocatoria si no tiene ID
                          // IMPORTANTE: Mantener isCreating en true durante todo el proceso del wizard
                          if (!editingId) {
                            // Guardar la convocatoria primero (sin enviar notificaciones aún)
                            try {
                              setLoading(true);
                              const response = await api.post('/api/v1/convocatorias/?enviar_notificaciones=false', formData);
                              const convocatoriaId = response.data.nro_convocatoria;
                              setEditingId(convocatoriaId);
                              // NO cambiar isCreating aquí - debe mantenerse en true durante el wizard
                              
                              // Guardar las órdenes
                              for (let index = 0; index < detallesPedidos.length; index++) {
                                const detalle = detallesPedidos[index];
                                if (detalle) {
                                  await guardarOrdenBD(detalle, index, convocatoriaId);
                                }
                              }
                              
                              // Cargar la convocatoria actualizada
                              const updatedResponse = await api.get(`/api/v1/convocatorias/${convocatoriaId}`);
                              setCurrentConvocatoria(updatedResponse.data);
                              
                              // Ahora subir el archivo
                              await handleEspecificacionesTecnicasUpload(convocatoriaId);
                            } catch (error) {
                              console.error('Error guardando convocatoria:', error);
                              setNotification({
                                show: true,
                                title: 'Error',
                                message: 'Error al guardar la convocatoria. Por favor intente nuevamente.',
                                type: 'error',
                                onConfirm: null
                              });
                            } finally {
                              setLoading(false);
                            }
                          } else {
                            await handleEspecificacionesTecnicasUpload(editingId);
                          }
                        }}
                        disabled={uploadingEspecificaciones || !especificacionesTecnicasFile}
                        style={{
                          padding: '0.75rem 1.5rem',
                          background: uploadingEspecificaciones || !especificacionesTecnicasFile ? '#ccc' : '#48bb78',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: uploadingEspecificaciones || !especificacionesTecnicasFile ? 'not-allowed' : 'pointer',
                          whiteSpace: 'nowrap',
                          fontWeight: '600'
                        }}
                      >
                        {uploadingEspecificaciones ? (
                          <>
                            <i className="bi bi-hourglass-split me-2"></i>Subiendo...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-upload me-2"></i>Subir Especificaciones
                          </>
                        )}
                      </button>
                    </div>
                    
                    {/* Barra de progreso de carga */}
                    {uploadingEspecificaciones && (
                      <div style={{ 
                        marginTop: '1.5rem', 
                        padding: '1.5rem', 
                        background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)', 
                        borderRadius: '12px', 
                        border: '2px solid #e9ecef',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.07)'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <div style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)'
                            }}>
                              <i className="bi bi-cloud-upload" style={{ color: 'white', fontSize: '1.2rem' }}></i>
                            </div>
                            <div>
                              <span style={{ color: '#495057', fontWeight: '600', fontSize: '1rem', display: 'block' }}>
                                Subiendo archivo...
                              </span>
                              <span style={{ color: '#6c757d', fontSize: '0.85rem' }}>
                                {especificacionesTecnicasFile?.name || 'Archivo'}
                              </span>
                            </div>
                          </div>
                          <div style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            background: `conic-gradient(from 0deg, #667eea ${uploadProgress * 3.6}deg, #e9ecef ${uploadProgress * 3.6}deg)`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(102, 126, 234, 0.2)'
                          }}>
                            <div style={{
                              width: '45px',
                              height: '45px',
                              borderRadius: '50%',
                              background: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              <span style={{ color: '#667eea', fontWeight: '700', fontSize: '0.9rem' }}>
                                {uploadProgress}%
                              </span>
                            </div>
                          </div>
                        </div>
                        <div style={{ 
                          width: '100%', 
                          height: '16px', 
                          backgroundColor: '#e9ecef', 
                          borderRadius: '10px', 
                          overflow: 'hidden',
                          boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
                          position: 'relative'
                        }}>
                          <div style={{
                            width: `${uploadProgress}%`,
                            height: '100%',
                            background: uploadProgress === 100 
                              ? 'linear-gradient(90deg, #48bb78 0%, #38a169 100%)'
                              : 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
                            borderRadius: '10px',
                            transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                            boxShadow: uploadProgress === 100 
                              ? '0 2px 8px rgba(72, 187, 120, 0.4)'
                              : '0 2px 8px rgba(102, 126, 234, 0.4)',
                            position: 'relative',
                            overflow: 'hidden'
                          }}>
                            {uploadProgress < 100 && uploadProgress > 0 && (
                              <div 
                                className="shimmer-animation"
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
                                  transform: 'translateX(-100%)'
                                }}
                              ></div>
                            )}
                          </div>
                        </div>
                        {uploadProgress === 100 && (
                          <div style={{ 
                            marginTop: '1rem', 
                            padding: '0.75rem', 
                            background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)',
                            borderRadius: '8px',
                            textAlign: 'center',
                            border: '1px solid #b1dfbb',
                            animation: 'fadeIn 0.5s ease-in'
                          }}>
                            <span style={{ color: '#155724', fontSize: '0.95rem', fontWeight: '600' }}>
                              <i className="bi bi-check-circle-fill me-2" style={{ fontSize: '1.1rem' }}></i>
                              ¡Carga completada exitosamente!
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                    
                    {currentConvocatoria?.especificaciones_tecnicas_pdf && !uploadingEspecificaciones && (
                      <div style={{ marginTop: '1rem', padding: '0.75rem', background: '#d1ecf1', borderRadius: '5px', border: '1px solid #bee5eb' }}>
                        <p style={{ margin: 0, color: '#0c5460', fontSize: '0.9rem' }}>
                          <i className="bi bi-check-circle-fill me-2"></i>
                          Archivo actual: <strong>{currentConvocatoria.especificaciones_tecnicas_pdf}</strong>
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Sección de Generar Solicitud de Cotización */}
                  <div style={{ padding: '1.5rem', background: 'white', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                    <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#2c3e50', display: 'flex', alignItems: 'center' }}>
                      <i className="bi bi-file-earmark-pdf me-2" style={{ color: '#4299e1' }}></i>
                      Solicitud de Cotización PDF
                    </h4>
                    <p style={{ marginBottom: '1rem', color: '#6c757d', fontSize: '0.9rem' }}>
                      Genere automáticamente un PDF de solicitud de cotización basado en los datos de la convocatoria y sus órdenes. 
                      Este documento incluirá toda la información necesaria para los proveedores.
                    </p>
                    {currentConvocatoria?.solicitud_cotizacion_pdf && (
                      <div style={{ marginBottom: '1rem', padding: '0.75rem', background: '#d1ecf1', borderRadius: '5px', border: '1px solid #bee5eb' }}>
                        <p style={{ margin: 0, color: '#0c5460', fontSize: '0.9rem' }}>
                          <i className="bi bi-check-circle-fill me-2"></i>
                          PDF generado: <strong>{currentConvocatoria.solicitud_cotizacion_pdf}</strong>
                        </p>
                      </div>
                    )}
                    <button
                      type="button"
                      onClick={async () => {
                        // Primero necesitamos guardar la convocatoria si no tiene ID
                        // IMPORTANTE: Mantener isCreating en true durante todo el proceso del wizard
                        if (!editingId) {
                          try {
                            setLoading(true);
                            // Guardar sin enviar notificaciones aún (solo se envían en el paso 5)
                            const response = await api.post('/api/v1/convocatorias/?enviar_notificaciones=false', formData);
                            const convocatoriaId = response.data.nro_convocatoria;
                            setEditingId(convocatoriaId);
                            // NO cambiar isCreating aquí - debe mantenerse en true durante el wizard
                            
                            // Guardar las órdenes
                            for (let index = 0; index < detallesPedidos.length; index++) {
                              const detalle = detallesPedidos[index];
                              if (detalle) {
                                await guardarOrdenBD(detalle, index, convocatoriaId);
                              }
                            }
                            
                            // Cargar la convocatoria actualizada
                            const updatedResponse = await api.get(`/api/v1/convocatorias/${convocatoriaId}`);
                            setCurrentConvocatoria(updatedResponse.data);
                            
                            // Ahora generar el PDF
                            await handleGenerarSolicitudCotizacion(convocatoriaId);
                          } catch (error) {
                            console.error('Error guardando convocatoria:', error);
                            setNotification({
                              show: true,
                              title: 'Error',
                              message: 'Error al guardar la convocatoria. Por favor intente nuevamente.',
                              type: 'error',
                              onConfirm: null
                            });
                          } finally {
                            setLoading(false);
                          }
                        } else {
                          await handleGenerarSolicitudCotizacion(editingId);
                        }
                      }}
                      disabled={generatingPDF}
                      style={{
                        padding: '0.75rem 2rem',
                        background: generatingPDF ? '#ccc' : '#4299e1',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: generatingPDF ? 'not-allowed' : 'pointer',
                        fontWeight: '600',
                        fontSize: '1rem'
                      }}
                    >
                      {generatingPDF ? (
                        <>
                          <i className="bi bi-hourglass-split me-2"></i>Generando PDF...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-file-earmark-pdf me-2"></i>Generar Solicitud de Cotización PDF
                        </>
                      )}
                    </button>
                  </div>

                  <div style={{ marginTop: '1.5rem', padding: '1.5rem', background: 'white', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                    <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#2c3e50', display: 'flex', alignItems: 'center' }}>
                      <i className="bi bi-files me-2" style={{ color: '#fd7e14' }}></i>
                      Formatos de postulación y otros documentos
                    </h4>
                    <p style={{ marginBottom: '1rem', color: '#6c757d', fontSize: '0.9rem' }}>
                      PDF opcionales visibles para los proveedores en el detalle de la convocatoria.
                    </p>
                    <div style={{ display: 'grid', gap: '1.25rem' }}>
                      <div style={{ padding: '1rem', background: '#fffaf5', borderRadius: '8px', border: '1px solid #ffe0c2' }}>
                        <h5 style={{ marginTop: 0, fontSize: '1rem', color: '#2c3e50' }}>Formatos de postulación</h5>
                        {currentConvocatoria?.formatos_postulacion_pdf && (
                          <p style={{ fontSize: '0.85rem', color: '#155724' }}>Actual: <strong>{currentConvocatoria.formatos_postulacion_pdf}</strong></p>
                        )}
                        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                          <input type="file" accept=".pdf" onChange={(e) => setFormatosPostulacionFile(e.target.files[0])} style={{ flex: '1', minWidth: '200px' }} />
                          <button
                            type="button"
                            disabled={uploadingFormatosPostulacion || !formatosPostulacionFile}
                            onClick={async () => {
                              if (!editingId) {
                                try {
                                  setLoading(true);
                                  const response = await api.post('/api/v1/convocatorias/?enviar_notificaciones=false', formData);
                                  const convocatoriaId = response.data.nro_convocatoria;
                                  setEditingId(convocatoriaId);
                                  for (let index = 0; index < detallesPedidos.length; index++) {
                                    const detalle = detallesPedidos[index];
                                    if (detalle) await guardarOrdenBD(detalle, index, convocatoriaId);
                                  }
                                  const updatedResponse = await api.get(`/api/v1/convocatorias/${convocatoriaId}`);
                                  setCurrentConvocatoria(updatedResponse.data);
                                  await handleFormatosPostulacionUpload(convocatoriaId);
                                } catch (error) {
                                  console.error(error);
                                  setNotification({ show: true, title: 'Error', message: 'No se pudo guardar la convocatoria antes de subir el archivo.', type: 'error', onConfirm: null });
                                } finally {
                                  setLoading(false);
                                }
                              } else {
                                await handleFormatosPostulacionUpload(editingId);
                              }
                            }}
                            style={{
                              padding: '0.5rem 1rem',
                              background: uploadingFormatosPostulacion || !formatosPostulacionFile ? '#ccc' : '#fd7e14',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: uploadingFormatosPostulacion || !formatosPostulacionFile ? 'not-allowed' : 'pointer',
                              fontWeight: 600,
                            }}
                          >
                            {uploadingFormatosPostulacion ? 'Subiendo…' : 'Subir'}
                          </button>
                        </div>
                      </div>
                      <div style={{ padding: '1rem', background: '#f8f5ff', borderRadius: '8px', border: '1px solid #e2d5f7' }}>
                        <h5 style={{ marginTop: 0, fontSize: '1rem', color: '#2c3e50' }}>Otros documentos</h5>
                        {currentConvocatoria?.otros_documentos_pdf && (
                          <p style={{ fontSize: '0.85rem', color: '#155724' }}>Actual: <strong>{currentConvocatoria.otros_documentos_pdf}</strong></p>
                        )}
                        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                          <input type="file" accept=".pdf" onChange={(e) => setOtrosDocumentosFile(e.target.files[0])} style={{ flex: '1', minWidth: '200px' }} />
                          <button
                            type="button"
                            disabled={uploadingOtrosDocumentos || !otrosDocumentosFile}
                            onClick={async () => {
                              if (!editingId) {
                                try {
                                  setLoading(true);
                                  const response = await api.post('/api/v1/convocatorias/?enviar_notificaciones=false', formData);
                                  const convocatoriaId = response.data.nro_convocatoria;
                                  setEditingId(convocatoriaId);
                                  for (let index = 0; index < detallesPedidos.length; index++) {
                                    const detalle = detallesPedidos[index];
                                    if (detalle) await guardarOrdenBD(detalle, index, convocatoriaId);
                                  }
                                  const updatedResponse = await api.get(`/api/v1/convocatorias/${convocatoriaId}`);
                                  setCurrentConvocatoria(updatedResponse.data);
                                  await handleOtrosDocumentosUpload(convocatoriaId);
                                } catch (error) {
                                  console.error(error);
                                  setNotification({ show: true, title: 'Error', message: 'No se pudo guardar la convocatoria antes de subir el archivo.', type: 'error', onConfirm: null });
                                } finally {
                                  setLoading(false);
                                }
                              } else {
                                await handleOtrosDocumentosUpload(editingId);
                              }
                            }}
                            style={{
                              padding: '0.5rem 1rem',
                              background: uploadingOtrosDocumentos || !otrosDocumentosFile ? '#ccc' : '#6f42c1',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: uploadingOtrosDocumentos || !otrosDocumentosFile ? 'not-allowed' : 'pointer',
                              fontWeight: 600,
                            }}
                          >
                            {uploadingOtrosDocumentos ? 'Subiendo…' : 'Subir'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
                    <p style={{ margin: 0, color: '#856404', fontSize: '0.9rem' }}>
                      <i className="bi bi-info-circle me-2"></i>
                      <strong>Nota:</strong> Estos documentos son opcionales. Puede continuar al siguiente paso sin cargarlos y hacerlo más tarde desde la edición de la convocatoria.
                    </p>
                  </div>
                </div>
              )}

              {/* Paso 5: Revisar y Guardar */}
              {currentStep === 5 && (
                <div style={{ padding: '1.5rem', background: '#f8f9fa', borderRadius: '10px', border: '1px solid #dee2e6' }}>
                  {convocatoriaGuardada ? (
                    /* Mensaje de éxito cuando la convocatoria se guardó */
                    <div style={{ 
                      background: 'white', 
                      padding: '2.5rem 2rem', 
                      borderRadius: '12px', 
                      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}>
                      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                        <div style={{
                          width: '80px',
                          height: '80px',
                          borderRadius: '50%',
                          background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 1.5rem',
                          boxShadow: '0 4px 12px rgba(40, 167, 69, 0.3)'
                        }}>
                          <i className="bi bi-check-circle-fill" style={{ color: 'white', fontSize: '3rem' }}></i>
                    </div>
                        <h3 style={{ color: '#28a745', marginBottom: '0.75rem', fontSize: '1.75rem', fontWeight: '700' }}>
                          ¡Convocatoria Guardada Exitosamente!
                        </h3>
                        <p style={{ color: '#6c757d', fontSize: '1rem', marginBottom: '1.5rem' }}>
                          La convocatoria ha sido guardada y publicada correctamente.
                        </p>
                        <div style={{
                          padding: '0.75rem 1.5rem',
                          background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)',
                          borderRadius: '8px',
                          border: '1px solid #b1dfbb',
                          display: 'inline-block',
                          marginBottom: '2rem'
                        }}>
                          <span style={{ color: '#155724', fontSize: '0.95rem', fontWeight: '600' }}>
                            <i className="bi bi-envelope-check-fill me-2" style={{ fontSize: '1.1rem' }}></i>
                            Notificaciones enviadas a los proveedores
                          </span>
                    </div>
                  </div>

                      {/* Resumen pequeño */}
                      <div style={{
                        background: '#f8f9fa',
                        padding: '1.5rem',
                        borderRadius: '8px',
                        border: '1px solid #dee2e6'
                      }}>
                        <h5 style={{ color: '#2c3e50', marginBottom: '1rem', fontSize: '1rem', fontWeight: '600' }}>
                          <i className="bi bi-info-circle me-2" style={{ color: '#667eea' }}></i>
                          Resumen de la Convocatoria
                        </h5>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                          <div>
                            <strong style={{ color: '#6c757d', fontSize: '0.875rem' }}>Código:</strong>
                            <div style={{ color: '#2c3e50', marginTop: '0.25rem', fontSize: '0.9rem' }}>
                              {currentConvocatoria?.COD_CONVOCATORIA || formData.nro_pedido || 'N/A'}
                            </div>
                          </div>
                          <div>
                            <strong style={{ color: '#6c757d', fontSize: '0.875rem' }}>Rubro:</strong>
                            <div style={{ color: '#2c3e50', marginTop: '0.25rem', fontSize: '0.9rem' }}>
                              {formData.rubro || 'N/A'}
                            </div>
                          </div>
                          <div>
                            <strong style={{ color: '#6c757d', fontSize: '0.875rem' }}>Concepto:</strong>
                            <div style={{ color: '#2c3e50', marginTop: '0.25rem', fontSize: '0.9rem' }}>
                              {formData.concepto || 'N/A'}
                            </div>
                          </div>
                          <div>
                            <strong style={{ color: '#6c757d', fontSize: '0.875rem' }}>Estado:</strong>
                            <div style={{ marginTop: '0.25rem' }}>
                              <span style={{
                                padding: '0.25rem 0.75rem',
                                borderRadius: '20px',
                                fontSize: '0.8rem',
                                fontWeight: '600',
                                background: formData.estado === 'ABIERTA' ? '#d4edda' : formData.estado === 'CERRADA' ? '#fff3cd' : '#d1ecf1',
                                color: formData.estado === 'ABIERTA' ? '#155724' : formData.estado === 'CERRADA' ? '#856404' : '#0c5460'
                              }}>
                                {formData.estado}
                              </span>
                            </div>
                          </div>
                          <div>
                            <strong style={{ color: '#6c757d', fontSize: '0.875rem' }}>Items:</strong>
                            <div style={{ color: '#2c3e50', marginTop: '0.25rem', fontSize: '0.9rem' }}>
                              {detallesPedidos.length} item(s)
                            </div>
                          </div>
                          <div>
                            <strong style={{ color: '#6c757d', fontSize: '0.875rem' }}>Ejecutora:</strong>
                            <div style={{ color: '#2c3e50', marginTop: '0.25rem', fontSize: '0.9rem' }}>
                              {formData.nombre_ejecutora || 'N/A'}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                  <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem' }}>
                    <h4 style={{ color: '#2c3e50', marginBottom: '1rem', borderBottom: '2px solid #667eea', paddingBottom: '0.5rem' }}>
                      <i className="bi bi-file-earmark-text me-2"></i>Resumen de la Convocatoria
                    </h4>
                    
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                      <div>
                        <strong style={{ color: '#6c757d' }}>Pedido SIGA:</strong>
                        <div style={{ color: '#2c3e50', marginTop: '0.25rem' }}>{formData.nro_pedido || 'N/A'}</div>
                      </div>
                      <div>
                        <strong style={{ color: '#6c757d' }}>Ejecutora:</strong>
                        <div style={{ color: '#2c3e50', marginTop: '0.25rem' }}>{formData.nombre_ejecutora || 'N/A'}</div>
                      </div>
                      <div>
                        <strong style={{ color: '#6c757d' }}>Rubro:</strong>
                        <div style={{ color: '#2c3e50', marginTop: '0.25rem' }}>{formData.rubro || 'N/A'}</div>
                      </div>
                      <div>
                        <strong style={{ color: '#6c757d' }}>Concepto:</strong>
                        <div style={{ color: '#2c3e50', marginTop: '0.25rem' }}>{formData.concepto || 'N/A'}</div>
                      </div>
                      <div>
                        <strong style={{ color: '#6c757d' }}>Estado:</strong>
                        <div style={{ marginTop: '0.25rem' }}>
                          <span style={{
                            padding: '0.25rem 0.75rem',
                            borderRadius: '20px',
                            fontSize: '0.85rem',
                            fontWeight: '600',
                            background: formData.estado === 'ABIERTA' ? '#d4edda' : formData.estado === 'CERRADA' ? '#fff3cd' : '#d1ecf1',
                            color: formData.estado === 'ABIERTA' ? '#155724' : formData.estado === 'CERRADA' ? '#856404' : '#0c5460'
                          }}>
                            {formData.estado}
                          </span>
                        </div>
                      </div>
                      <div>
                        <strong style={{ color: '#6c757d' }}>Items del Pedido:</strong>
                        <div style={{ color: '#2c3e50', marginTop: '0.25rem' }}>{detallesPedidos.length} item(s)</div>
                      </div>
                    </div>

                    {formData.motivo_pedido && (
                      <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #dee2e6' }}>
                        <strong style={{ color: '#6c757d' }}>Motivo del Pedido:</strong>
                        <div style={{ color: '#2c3e50', marginTop: '0.5rem', padding: '0.75rem', background: '#f8f9fa', borderRadius: '5px' }}>
                          {formData.motivo_pedido}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Barra de progreso de guardado */}
                  {loading && (
                    <div style={{ 
                      marginBottom: '1.5rem', 
                      padding: '1.5rem', 
                      background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)', 
                      borderRadius: '12px', 
                      border: '2px solid #e9ecef',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.07)'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                          <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(40, 167, 69, 0.3)'
                          }}>
                            <i className="bi bi-save" style={{ color: 'white', fontSize: '1.2rem' }}></i>
                          </div>
                          <div>
                            <span style={{ color: '#495057', fontWeight: '600', fontSize: '1rem', display: 'block' }}>
                              Guardando convocatoria...
                            </span>
                            <span style={{ color: '#6c757d', fontSize: '0.85rem' }}>
                              Por favor espere, esto puede tomar unos momentos
                            </span>
                          </div>
                        </div>
                        <div style={{
                          width: '60px',
                          height: '60px',
                          borderRadius: '50%',
                          background: `conic-gradient(from 0deg, #28a745 ${saveProgress * 3.6}deg, #e9ecef ${saveProgress * 3.6}deg)`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0 2px 8px rgba(40, 167, 69, 0.2)'
                        }}>
                          <div style={{
                            width: '45px',
                            height: '45px',
                            borderRadius: '50%',
                            background: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                            <span style={{ color: '#28a745', fontWeight: '700', fontSize: '0.9rem' }}>
                              {saveProgress}%
                            </span>
                          </div>
                        </div>
                      </div>
                      <div style={{ 
                        width: '100%', 
                        height: '16px', 
                        backgroundColor: '#e9ecef', 
                        borderRadius: '10px', 
                        overflow: 'hidden',
                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
                        position: 'relative'
                      }}>
                        <div style={{
                          width: `${saveProgress}%`,
                          height: '100%',
                          background: saveProgress === 100 
                            ? 'linear-gradient(90deg, #28a745 0%, #20c997 100%)'
                            : 'linear-gradient(90deg, #28a745 0%, #20c997 100%)',
                          borderRadius: '10px',
                          transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                          boxShadow: saveProgress === 100 
                            ? '0 2px 8px rgba(40, 167, 69, 0.4)'
                            : '0 2px 8px rgba(40, 167, 69, 0.4)',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          {saveProgress < 100 && saveProgress > 0 && (
                            <div 
                              className="shimmer-animation"
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
                                transform: 'translateX(-100%)'
                              }}
                            ></div>
                          )}
                        </div>
                      </div>
                      {saveProgress === 100 && (
                        <div style={{ 
                          marginTop: '1rem', 
                          padding: '0.75rem', 
                          background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)',
                          borderRadius: '8px',
                          textAlign: 'center',
                          border: '1px solid #b1dfbb',
                          animation: 'fadeIn 0.5s ease-in'
                        }}>
                          <span style={{ color: '#155724', fontSize: '0.95rem', fontWeight: '600' }}>
                            <i className="bi bi-check-circle-fill me-2" style={{ fontSize: '1.1rem' }}></i>
                            ¡Convocatoria guardada exitosamente!
                          </span>
                        </div>
                      )}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
                      <button 
                        type="submit" 
                        disabled={loading}
                        style={{ 
                          padding: '0.75rem 2rem', 
                          background: loading ? '#ccc' : '#28a745', 
                          color: 'white', 
                          border: 'none', 
                          borderRadius: '8px', 
                          cursor: loading ? 'not-allowed' : 'pointer',
                          fontWeight: '600',
                          fontSize: '1rem'
                        }}
                      >
                        {loading ? (
                          <>
                            <i className="bi bi-hourglass-split me-2"></i>Guardando...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-check-circle me-2"></i>Guardar Convocatoria
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                    </>
                  )}
                </div>
              )}

              {/* Botones de Navegación (excepto en paso 5 y cuando se guardó) */}
              {currentStep < 5 && !convocatoriaGuardada && (
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem', paddingTop: '1.5rem', borderTop: '2px solid #dee2e6' }}>
                  <button 
                    type="button"
                    onClick={prevStep}
                    disabled={currentStep === 1}
                    style={{ 
                      padding: '0.75rem 1.5rem', 
                      background: currentStep === 1 ? '#e9ecef' : '#6c757d', 
                      color: currentStep === 1 ? '#adb5bd' : 'white', 
                      border: 'none', 
                      borderRadius: '8px', 
                      cursor: currentStep === 1 ? 'not-allowed' : 'pointer',
                      fontWeight: '600'
                    }}
                  >
                    <i className="bi bi-arrow-left me-2"></i>Anterior
                  </button>
                  <button 
                    type="button"
                    onClick={nextStep}
                    style={{ 
                      padding: '0.75rem 2rem', 
                      background: validateStep(currentStep) ? '#667eea' : '#ccc', 
                      color: 'white', 
                      border: 'none', 
                      borderRadius: '8px', 
                      cursor: validateStep(currentStep) ? 'pointer' : 'not-allowed',
                      fontWeight: '600',
                      fontSize: '1rem'
                    }}
                  >
                    Siguiente<i className="bi bi-arrow-right ms-2"></i>
                  </button>
                </div>
              )}
            </div>
            </>
          )}

          {/* Formulario de Edición (modo edición) - Solo mostrar cuando NO estamos en proceso de creación y NO se acaba de guardar */}
          {editingId && !isCreating && !convocatoriaGuardada && (
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
              {/* Campos de solo lectura para edición - Año y Nro Pedido */}
              {editingId && (
                <>
                  <div>
                    <label>Año Eje (SIGA) *</label>
                    <input type="text" value={formData.ano_eje || ''} readOnly style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px', background: '#f0f0f0', cursor: 'not-allowed' }} />
                  </div>
                  <div>
                    <label>Nro Pedido (SIGA) *</label>
                    <input type="text" value={formData.nro_pedido || ''} readOnly style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px', background: '#f0f0f0', cursor: 'not-allowed' }} />
                  </div>
                  <div>
                    <label>Nombre Ejecutora (SIGA)</label>
                    <input type="text" value={formData.nombre_ejecutora || ''} readOnly style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px', background: '#f0f0f0', cursor: 'not-allowed' }} />
                  </div>
                  <div>
                    <label>Tipo Bien (SIGA)</label>
                    <input type="text" value={formData.tipo_bien || ''} readOnly style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px', background: '#f0f0f0', cursor: 'not-allowed' }} />
                  </div>
                  <div>
                    <label>Tipo Pedido (SIGA)</label>
                    <input type="text" value={formData.tipo_pedido || ''} readOnly style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px', background: '#f0f0f0', cursor: 'not-allowed' }} />
                  </div>
                  <div>
                    <label>Centro Costo (SIGA)</label>
                    <input type="text" value={formData.centro_costo || ''} readOnly style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px', background: '#f0f0f0', cursor: 'not-allowed' }} />
                  </div>
                  <div>
                    <label>Nombre Dependencia (SIGA)</label>
                    <input type="text" value={formData.nombre_depend || ''} readOnly style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px', background: '#f0f0f0', cursor: 'not-allowed' }} />
                  </div>
                  <div>
                    <label>Fecha Pedido (SIGA)</label>
                    <input type="date" value={formData.fecha_pedido || ''} readOnly style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px', background: '#f0f0f0', cursor: 'not-allowed' }} />
                  </div>
                  <div style={{ gridColumn: 'span 2' }}>
                    <label>Motivo Pedido (SIGA) *</label>
                    <textarea 
                      value={formData.motivo_pedido || ''} 
                      onChange={(e) => setFormData({ ...formData, motivo_pedido: e.target.value })}
                      rows={4}
                      style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px' }}
                    />
                  </div>
                </>
              )}
              <div>
                <label>Rubro *</label>
                <input
                  type="text"
                  value={formData.rubro}
                  onChange={(e) => setFormData({ ...formData, rubro: e.target.value })}
                  required
                  style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px' }}
                />
              </div>
              <div>
                <label>Concepto *</label>
                <input
                  type="text"
                  value={formData.concepto}
                  onChange={(e) => setFormData({ ...formData, concepto: e.target.value })}
                  required
                  style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px' }}
                />
              </div>
              <div>
                <label>Estado *</label>
                <select
                  value={formData.estado}
                  onChange={(e) => setFormData({ ...formData, estado: e.target.value })}
                  required
                  style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px' }}
                >
                  <option value="ABIERTA">ABIERTA</option>
                  <option value="CERRADA">CERRADA</option>
                  <option value="EVALUACION">EVALUACION</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </div>
              <div>
                <label>Fecha Inicio</label>
                <input
                  type="date"
                  value={formData.fecha_inicio}
                  onChange={(e) => setFormData({ ...formData, fecha_inicio: e.target.value })}
                  style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px' }}
                />
              </div>
              <div>
                <label>Fecha y hora de cierre</label>
                <input
                  type="datetime-local"
                  value={formData.fecha_fin}
                  onChange={(e) => setFormData({ ...formData, fecha_fin: e.target.value })}
                  style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px' }}
                />
              </div>
            </div>

            {/* Sección de Especificaciones Técnicas - Solo para edición */}
            {editingId && (
              <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#2c3e50' }}>Especificaciones Técnicas</h4>
                {currentConvocatoria?.especificaciones_tecnicas_pdf && (
                  <div style={{ marginBottom: '1rem', padding: '0.75rem', background: '#d4edda', borderRadius: '5px', border: '1px solid #c3e6cb' }}>
                    <p style={{ margin: 0, color: '#155724', fontSize: '0.9rem' }}>
                      ✓ Archivo actual: <strong>{currentConvocatoria.especificaciones_tecnicas_pdf}</strong>
                    </p>
                  </div>
                )}
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-end' }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Subir PDF de Especificaciones Técnicas:</label>
                    <input
                      type="file"
                      accept=".pdf"
                      onChange={(e) => setEspecificacionesTecnicasFile(e.target.files[0])}
                      style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px' }}
                    />
                    {especificacionesTecnicasFile && (
                      <p style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: '#28a745' }}>
                        ✓ Archivo seleccionado: {especificacionesTecnicasFile.name}
                      </p>
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={() => handleEspecificacionesTecnicasUpload(editingId)}
                    disabled={uploadingEspecificaciones || !especificacionesTecnicasFile}
                    style={{
                      padding: '0.75rem 1.5rem',
                      background: uploadingEspecificaciones || !especificacionesTecnicasFile ? '#ccc' : '#48bb78',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: uploadingEspecificaciones || !especificacionesTecnicasFile ? 'not-allowed' : 'pointer',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {uploadingEspecificaciones ? 'Subiendo...' : currentConvocatoria?.especificaciones_tecnicas_pdf ? 'Reemplazar' : 'Subir Especificaciones'}
                  </button>
                </div>
              </div>
            )}

            {editingId && (
              <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#fffaf5', borderRadius: '8px', border: '1px solid #ffe0c2' }}>
                <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#2c3e50' }}>Formatos de postulación</h4>
                {currentConvocatoria?.formatos_postulacion_pdf && (
                  <p style={{ fontSize: '0.875rem', color: '#155724' }}>Archivo actual: <strong>{currentConvocatoria.formatos_postulacion_pdf}</strong></p>
                )}
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                  <div style={{ flex: 1, minWidth: '200px' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>PDF:</label>
                    <input type="file" accept=".pdf" onChange={(e) => setFormatosPostulacionFile(e.target.files[0])} style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px' }} />
                  </div>
                  <button
                    type="button"
                    onClick={() => handleFormatosPostulacionUpload(editingId)}
                    disabled={uploadingFormatosPostulacion || !formatosPostulacionFile}
                    style={{
                      padding: '0.75rem 1.5rem',
                      background: uploadingFormatosPostulacion || !formatosPostulacionFile ? '#ccc' : '#fd7e14',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: uploadingFormatosPostulacion || !formatosPostulacionFile ? 'not-allowed' : 'pointer',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {uploadingFormatosPostulacion ? 'Subiendo...' : currentConvocatoria?.formatos_postulacion_pdf ? 'Reemplazar' : 'Subir'}
                  </button>
                </div>
              </div>
            )}

            {editingId && (
              <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#f8f5ff', borderRadius: '8px', border: '1px solid #e2d5f7' }}>
                <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#2c3e50' }}>Otros documentos</h4>
                {currentConvocatoria?.otros_documentos_pdf && (
                  <p style={{ fontSize: '0.875rem', color: '#155724' }}>Archivo actual: <strong>{currentConvocatoria.otros_documentos_pdf}</strong></p>
                )}
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                  <div style={{ flex: 1, minWidth: '200px' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>PDF:</label>
                    <input type="file" accept=".pdf" onChange={(e) => setOtrosDocumentosFile(e.target.files[0])} style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '5px' }} />
                  </div>
                  <button
                    type="button"
                    onClick={() => handleOtrosDocumentosUpload(editingId)}
                    disabled={uploadingOtrosDocumentos || !otrosDocumentosFile}
                    style={{
                      padding: '0.75rem 1.5rem',
                      background: uploadingOtrosDocumentos || !otrosDocumentosFile ? '#ccc' : '#6f42c1',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: uploadingOtrosDocumentos || !otrosDocumentosFile ? 'not-allowed' : 'pointer',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {uploadingOtrosDocumentos ? 'Subiendo...' : currentConvocatoria?.otros_documentos_pdf ? 'Reemplazar' : 'Subir'}
                  </button>
                </div>
              </div>
            )}

            {/* Botón para generar Solicitud de Cotización - Solo para edición */}
            {editingId && (
              <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#e6f3ff', borderRadius: '8px', border: '1px solid #b3d9ff' }}>
                <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#2c3e50' }}>Solicitud de Cotización</h4>
                {currentConvocatoria?.solicitud_cotizacion_pdf && (
                  <div style={{ marginBottom: '1rem', padding: '0.75rem', background: '#d1ecf1', borderRadius: '5px', border: '1px solid #bee5eb' }}>
                    <p style={{ margin: 0, color: '#0c5460', fontSize: '0.9rem' }}>
                      ✓ PDF generado: <strong>{currentConvocatoria.solicitud_cotizacion_pdf}</strong>
                    </p>
                  </div>
                )}
                <p style={{ marginBottom: '1rem', color: '#666', fontSize: '0.9rem' }}>
                  Genera automáticamente un PDF de solicitud de cotización basado en los datos de la convocatoria y sus órdenes.
                </p>
                <button
                  type="button"
                  onClick={() => handleGenerarSolicitudCotizacion(editingId)}
                  disabled={generatingPDF}
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: generatingPDF ? '#ccc' : '#4299e1',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: generatingPDF ? 'not-allowed' : 'pointer',
                    fontWeight: 'bold'
                  }}
                >
                  {generatingPDF ? 'Generando PDF...' : '📄 Generar Solicitud de Cotización PDF'}
                </button>
              </div>
            )}

          {/* Sección de Detalles de Pedidos */}
          {selectedPedido && formData.ano_eje && (
            <div style={{ marginTop: '2rem', background: '#f8f9fa', padding: '1.5rem', borderRadius: '10px' }}>
              <h3 style={{ marginBottom: '1rem', color: '#2c3e50' }}>Detalles del Pedido SIGA</h3>
              
              {loadingDetalles ? (
                <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                  Cargando detalles...
                </div>
              ) : detallesPedidos.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                  No se encontraron detalles para este pedido.
                </div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
                    <thead>
                      <tr style={{ background: '#667eea', color: 'white' }}>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Secuencia</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Item</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Nombre Item</th>
                        <th style={{ padding: '0.75rem', textAlign: 'right', border: '1px solid #ddd' }}>Cantidad</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Unidad Medida</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Características</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Detalles</th>
                        <th style={{ padding: '0.75rem', textAlign: 'center', border: '1px solid #ddd' }}>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detallesPedidos.map((detalle, index) => (
                        <tr key={index} style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{detalle.SECUENCIA}</td>
                          <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>
                            {detalle.GRUPO_BIEN}-{detalle.CLASE_BIEN}-{detalle.FAMILIA_BIEN}-{detalle.ITEM_BIEN}
                          </td>
                          <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{detalle.NOMBRE_ITEM || 'N/A'}</td>
                          <td style={{ padding: '0.75rem', textAlign: 'right', border: '1px solid #ddd' }}>
                            {editingDetalle === index ? (
                              <input
                                type="number"
                                value={detalleData[`${index}_cant_solicitada`] || detalle.CANT_SOLICITADA || ''}
                                onChange={(e) => setDetalleData({...detalleData, [`${index}_cant_solicitada`]: e.target.value})}
                                style={{ width: '100%', padding: '0.5rem', border: '1px solid #ccc', borderRadius: '3px', fontSize: '0.875rem', textAlign: 'right' }}
                                min="0"
                                step="0.01"
                              />
                            ) : (
                              Math.round(Number(detalleData[`${index}_cant_solicitada`] || detalle.CANT_SOLICITADA || 0))
                            )}
                          </td>
                          <td style={{ padding: '0.5rem', border: '1px solid #ddd' }}>
                            {editingDetalle === index ? (
                              <select
                                value={detalleData[`${index}_unidad_medida`] || detalle.unidad_medida || 'UN - Unidad'}
                                onChange={(e) => setDetalleData({...detalleData, [`${index}_unidad_medida`]: e.target.value})}
                                style={{ width: '100%', padding: '0.5rem', border: '1px solid #ccc', borderRadius: '3px', fontSize: '0.875rem' }}
                              >
                                {unidadesMedida.map(um => (
                                  <option key={um.value} value={um.label}>{um.label}</option>
                                ))}
                              </select>
                            ) : (
                              detalleData[`${index}_unidad_medida`] || detalle.unidad_medida || 'UN - Unidad'
                            )}
                          </td>
                          <td style={{ padding: '0.5rem', border: '1px solid #ddd' }}>
                            {editingDetalle === index ? (
                              <input
                                type="text"
                                value={detalleData[`${index}_caracteristicas`] || detalle.caracteristicas || ''}
                                onChange={(e) => setDetalleData({...detalleData, [`${index}_caracteristicas`]: e.target.value})}
                                style={{ width: '100%', padding: '0.25rem', border: '1px solid #ccc', borderRadius: '3px' }}
                                placeholder="Características"
                              />
                            ) : (
                              detalleData[`${index}_caracteristicas`] || detalle.caracteristicas || '-'
                            )}
                          </td>
                          <td style={{ padding: '0.5rem', border: '1px solid #ddd' }}>
                            {editingDetalle === index ? (
                              <input
                                type="text"
                                value={detalleData[`${index}_detalles`] || detalle.detalles || ''}
                                onChange={(e) => setDetalleData({...detalleData, [`${index}_detalles`]: e.target.value})}
                                style={{ width: '100%', padding: '0.25rem', border: '1px solid #ccc', borderRadius: '3px' }}
                                placeholder="Detalles"
                              />
                            ) : (
                              detalleData[`${index}_detalles`] || detalle.detalles || '-'
                            )}
                          </td>
                          <td style={{ padding: '0.75rem', textAlign: 'center', border: '1px solid #ddd' }}>
                            <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                              {editingDetalle === index ? (
                                <>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setEditingDetalle(null);
                                    }}
                                    style={{
                                      padding: '0.5rem 1rem',
                                      background: '#48bb78',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '5px',
                                      cursor: 'pointer',
                                      fontSize: '0.875rem'
                                    }}
                                  >
                                    ✓ Listo
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setEditingDetalle(null);
                                      const newData = {...detalleData};
                                      delete newData[`${index}_unidad_medida`];
                                      delete newData[`${index}_caracteristicas`];
                                      delete newData[`${index}_detalles`];
                                      setDetalleData(newData);
                                    }}
                                    style={{
                                      padding: '0.5rem 1rem',
                                      background: '#cbd5e0',
                                      color: '#4a5568',
                                      border: 'none',
                                      borderRadius: '5px',
                                      cursor: 'pointer',
                                      fontSize: '0.875rem'
                                    }}
                                  >
                                    Cancelar
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    type="button"
                                    onClick={() => setEditingDetalle(index)}
                                    style={{
                                      padding: '0.5rem 1rem',
                                      background: '#4299e1',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '5px',
                                      cursor: 'pointer',
                                      fontSize: '0.875rem'
                                    }}
                                  >
                                    ✎ Editar
                                  </button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            )}

            <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
              <button type="submit" disabled={loading} style={{ padding: '0.75rem 1.5rem', background: '#667eea', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                {loading ? 'Guardando...' : 'Actualizar Convocatoria'}
              </button>
              <button type="button" onClick={resetForm} style={{ padding: '0.75rem 1.5rem', background: '#ccc', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                Limpiar
              </button>
            </div>
          </form>
          )}

          {/* Sección de Órdenes Guardadas */}
          {editingId && ordenesGuardadas.length > 0 && (
            <div style={{ marginTop: '2rem', background: '#e6fffa', padding: '1.5rem', borderRadius: '10px' }}>
              <h3 style={{ marginBottom: '1rem', color: '#2c3e50' }}>Órdenes Guardadas ({ordenesGuardadas.length})</h3>
              
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
                  <thead>
                    <tr style={{ background: '#48bb78', color: 'white' }}>
                      <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Secuencia</th>
                      <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Item</th>
                      <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Nombre Item</th>
                      <th style={{ padding: '0.75rem', textAlign: 'right', border: '1px solid #ddd' }}>Cantidad</th>
                      <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Unidad Medida</th>
                      <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Características</th>
                      <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Detalles</th>
                      <th style={{ padding: '0.75rem', textAlign: 'center', border: '1px solid #ddd' }}>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ordenesGuardadas.map((orden) => (
                      <tr key={orden.id_orden} style={{ borderBottom: '1px solid #e2e8f0' }}>
                        <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{orden.secuencia}</td>
                        <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>
                          {orden.grupo_bien}-{orden.clase_bien}-{orden.familia_bien}-{orden.item_bien}
                        </td>
                        <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{orden.nombre_item || 'N/A'}</td>
                        <td style={{ padding: '0.75rem', textAlign: 'right', border: '1px solid #ddd' }}>
                          {editingOrdenId === orden.id_orden ? (
                            <input
                              type="number"
                              value={ordenEditData[`${orden.id_orden}_cant_solicitada`] !== undefined ? ordenEditData[`${orden.id_orden}_cant_solicitada`] : orden.cant_solicitada}
                              onChange={(e) => setOrdenEditData({...ordenEditData, [`${orden.id_orden}_cant_solicitada`]: e.target.value})}
                              style={{ width: '100%', padding: '0.5rem', border: '1px solid #ccc', borderRadius: '3px', fontSize: '0.875rem', textAlign: 'right' }}
                              min="0"
                              step="0.01"
                            />
                          ) : (
                            Math.round(Number(orden.cant_solicitada || 0))
                          )}
                        </td>
                        <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>
                          {editingOrdenId === orden.id_orden ? (
                            <select
                              value={ordenEditData[`${orden.id_orden}_unidad_medida`] !== undefined ? ordenEditData[`${orden.id_orden}_unidad_medida`] : orden.unidad_medida}
                              onChange={(e) => setOrdenEditData({...ordenEditData, [`${orden.id_orden}_unidad_medida`]: e.target.value})}
                              style={{ width: '100%', padding: '0.5rem', border: '1px solid #ccc', borderRadius: '3px', fontSize: '0.875rem' }}
                            >
                              {unidadesMedida.map(um => (
                                <option key={um.value} value={um.label}>{um.label}</option>
                              ))}
                            </select>
                          ) : (
                            orden.unidad_medida || 'UN - Unidad'
                          )}
                        </td>
                        <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>
                          {editingOrdenId === orden.id_orden ? (
                            <input
                              type="text"
                              value={ordenEditData[`${orden.id_orden}_caracteristicas`] !== undefined ? ordenEditData[`${orden.id_orden}_caracteristicas`] : (orden.caracteristicas || '')}
                              onChange={(e) => setOrdenEditData({...ordenEditData, [`${orden.id_orden}_caracteristicas`]: e.target.value})}
                              style={{ width: '100%', padding: '0.5rem', border: '1px solid #ccc', borderRadius: '3px', fontSize: '0.875rem' }}
                            />
                          ) : (
                            orden.caracteristicas || '-'
                          )}
                        </td>
                        <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>
                          {editingOrdenId === orden.id_orden ? (
                            <input
                              type="text"
                              value={ordenEditData[`${orden.id_orden}_detalles`] !== undefined ? ordenEditData[`${orden.id_orden}_detalles`] : (orden.detalles || '')}
                              onChange={(e) => setOrdenEditData({...ordenEditData, [`${orden.id_orden}_detalles`]: e.target.value})}
                              style={{ width: '100%', padding: '0.5rem', border: '1px solid #ccc', borderRadius: '3px', fontSize: '0.875rem' }}
                            />
                          ) : (
                            orden.detalles || '-'
                          )}
                        </td>
                        <td style={{ padding: '0.75rem', textAlign: 'center', border: '1px solid #ddd' }}>
                          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                            {editingOrdenId === orden.id_orden ? (
                              <>
                                <button
                                  type="button"
                                  onClick={async () => {
                                    try {
                                      const ordenData = {
                                        ano_eje: orden.ano_eje,
                                        sec_ejec: orden.sec_ejec,
                                        tipo_pedido: orden.tipo_pedido,
                                        tipo_bien: orden.tipo_bien,
                                        nro_pedido: orden.nro_pedido,
                                        secuencia: orden.secuencia,
                                        grupo_bien: orden.grupo_bien,
                                        clase_bien: orden.clase_bien,
                                        familia_bien: orden.familia_bien,
                                        item_bien: orden.item_bien,
                                        cant_solicitada: ordenEditData[`${orden.id_orden}_cant_solicitada`] !== undefined ? ordenEditData[`${orden.id_orden}_cant_solicitada`] : orden.cant_solicitada,
                                        centro_costo: orden.centro_costo,
                                        nombre_depend: orden.nombre_depend,
                                        nombre_item: orden.nombre_item,
                                        unidad_medida: ordenEditData[`${orden.id_orden}_unidad_medida`] !== undefined ? ordenEditData[`${orden.id_orden}_unidad_medida`] : orden.unidad_medida,
                                        caracteristicas: ordenEditData[`${orden.id_orden}_caracteristicas`] !== undefined ? ordenEditData[`${orden.id_orden}_caracteristicas`] : orden.caracteristicas,
                                        detalles: ordenEditData[`${orden.id_orden}_detalles`] !== undefined ? ordenEditData[`${orden.id_orden}_detalles`] : orden.detalles,
                                        id_convocatoria: orden.id_convocatoria
                                      };
                                      await api.put(`/api/v1/ordenes/${orden.id_orden}`, ordenData);
                                      setEditingOrdenId(null);
                                      setOrdenEditData({});
                                      await loadOrdenesGuardadas(editingId);
                                      alert('Orden actualizada exitosamente');
                                    } catch (error) {
                                      console.error('Error actualizando orden:', error);
                                      alert('Error al actualizar la orden');
                                    }
                                  }}
                                  style={{
                                    padding: '0.5rem 1rem',
                                    background: '#48bb78',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  Guardar
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setEditingOrdenId(null);
                                    setOrdenEditData({});
                                  }}
                                  style={{
                                    padding: '0.5rem 1rem',
                                    background: '#cbd5e0',
                                    color: '#4a5568',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  Cancelar
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setEditingOrdenId(orden.id_orden);
                                    setOrdenEditData({
                                      [`${orden.id_orden}_cant_solicitada`]: orden.cant_solicitada,
                                      [`${orden.id_orden}_unidad_medida`]: orden.unidad_medida,
                                      [`${orden.id_orden}_caracteristicas`]: orden.caracteristicas,
                                      [`${orden.id_orden}_detalles`]: orden.detalles
                                    });
                                  }}
                                  style={{
                                    padding: '0.5rem 1rem',
                                    background: '#4299e1',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  Editar
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleEliminarOrden(orden.id_orden)}
                                  style={{
                                    padding: '0.5rem 1rem',
                                    background: '#f56565',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  Eliminar
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Lista de convocatorias - Solo se muestra cuando el formulario está cerrado */}
      {!showForm && (
        <div style={{ background: 'white', padding: '2rem', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="h4 mb-1 fw-bold">Lista de Convocatorias</h2>
              <p className="text-muted mb-0">
                {Array.isArray(convocatorias) && convocatorias.length > 0 
                  ? `Total: ${convocatorias.length} convocatoria${convocatorias.length !== 1 ? 's' : ''} - Mostrando: ${getFilteredConvocatorias().length}`
                  : 'No hay convocatorias registradas'}
              </p>
            </div>
          </div>

          {/* Resumen de estadísticas */}
          {Array.isArray(convocatorias) && convocatorias.length > 0 && (
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', 
              gap: '1rem', 
              marginBottom: '1.5rem' 
            }}>
              {getEstadosUnicos().map(estado => {
                const count = Array.isArray(convocatorias) ? convocatorias.filter(c => c.estado === estado).length : 0;
                const badge = getEstadoBadgeColor(estado);
                return (
                  <div 
                    key={estado}
                    style={{
                      background: 'white',
                      padding: '1rem',
                      borderRadius: '8px',
                      border: `2px solid ${badge.border}`,
                      textAlign: 'center',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  >
                    <div style={{ fontSize: '1.75rem', fontWeight: 'bold', color: badge.color, marginBottom: '0.25rem' }}>
                      {count}
                    </div>
                    <div style={{ fontSize: '0.85rem', color: '#6c757d', fontWeight: '500' }}>
                      {estado}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Barra de búsqueda y filtros */}
          {Array.isArray(convocatorias) && convocatorias.length > 0 && (
            <div style={{ 
              background: '#f8f9fa', 
              padding: '1.5rem', 
              borderRadius: '8px', 
              marginBottom: '1.5rem',
              border: '1px solid #dee2e6'
            }}>
              <div className="mb-3">
                <label className="form-label fw-semibold mb-2">
                  <i className="bi bi-search me-2"></i>Buscar Convocatorias
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Buscar por código de convocatoria, número, pedido, ejecutora, motivo del pedido, rubro, concepto, dependencia..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ 
                    fontSize: '0.95rem',
                    padding: '0.75rem 1rem'
                  }}
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                <div>
                  <label className="form-label fw-semibold mb-2">Filtrar por Estado</label>
                  <select
                    className="form-select"
                    value={filterEstado}
                    onChange={(e) => setFilterEstado(e.target.value)}
                    style={{ fontSize: '0.9rem' }}
                  >
                    <option value="">Todos los estados</option>
                    {getEstadosUnicos().map(estado => (
                      <option key={estado} value={estado}>{estado}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="form-label fw-semibold mb-2">Filtrar por Año</label>
                  <select
                    className="form-select"
                    value={filterAno}
                    onChange={(e) => setFilterAno(e.target.value)}
                    style={{ fontSize: '0.9rem' }}
                  >
                    <option value="">Todos los años</option>
                    {getAnosUnicos().map(ano => (
                      <option key={ano} value={ano}>{ano}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="form-label fw-semibold mb-2">Filtrar por Rubro</label>
                  <select
                    className="form-select"
                    value={filterRubro}
                    onChange={(e) => setFilterRubro(e.target.value)}
                    style={{ fontSize: '0.9rem' }}
                  >
                    <option value="">Todos los rubros</option>
                    {getRubrosUnicos().map(rubro => (
                      <option key={rubro} value={rubro}>{rubro}</option>
                    ))}
                  </select>
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <button
                    type="button"
                    className="btn btn-outline-secondary w-100"
                    onClick={() => {
                      setSearchTerm('');
                      setFilterEstado('');
                      setFilterAno('');
                      setFilterRubro('');
                    }}
                    style={{ fontSize: '0.9rem' }}
                  >
                    <i className="bi bi-x-circle me-2"></i>
                    Limpiar Filtros
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Tabla de convocatorias */}
          {loadingConvocatorias ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: '#666' }}>
              <div className="spinner-border text-primary" role="status" style={{ marginBottom: '1rem' }}>
                <span className="visually-hidden">Cargando...</span>
              </div>
              <p style={{ fontSize: '1rem', margin: 0 }}>Cargando convocatorias...</p>
            </div>
          ) : !Array.isArray(convocatorias) || convocatorias.length === 0 ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: '#666' }}>
              <i className="bi bi-inbox" style={{ fontSize: '3rem', color: '#ccc', marginBottom: '1rem', display: 'block' }}></i>
              <p style={{ fontSize: '1.1rem', margin: 0 }}>No hay convocatorias registradas aún.</p>
              <p style={{ fontSize: '0.9rem', color: '#999', marginTop: '0.5rem' }}>Crea una nueva convocatoria usando el botón de arriba.</p>
            </div>
          ) : getFilteredConvocatorias().length === 0 ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: '#666' }}>
              <i className="bi bi-search" style={{ fontSize: '3rem', color: '#ccc', marginBottom: '1rem', display: 'block' }}></i>
              <p style={{ fontSize: '1.1rem', margin: 0 }}>No se encontraron convocatorias con los filtros seleccionados.</p>
              <button
                type="button"
                className="btn btn-link mt-2"
                onClick={() => {
                  setSearchTerm('');
                  setFilterEstado('');
                  setFilterAno('');
                  setFilterRubro('');
                }}
              >
                Limpiar filtros
              </button>
            </div>
          ) : (
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
              <table className="table table-hover align-middle" style={{ marginBottom: 0, minWidth: '1000px' }}>
                <thead style={{ background: '#667eea', color: 'white' }}>
                  <tr>
                    <th style={{ padding: '1rem', fontWeight: '600', border: 'none' }}>ID</th>
                    <th style={{ padding: '1rem', fontWeight: '600', border: 'none' }}>Número de Convocatoria</th>
                    <th style={{ padding: '1rem', fontWeight: '600', border: 'none' }}>Nro Pedido</th>
                    <th style={{ padding: '1rem', fontWeight: '600', border: 'none' }}>Ejecutora</th>
                    <th style={{ padding: '1rem', fontWeight: '600', border: 'none' }}>Motivo del Pedido</th>
                    <th style={{ padding: '1rem', fontWeight: '600', border: 'none' }}>Estado</th>
                    <th style={{ padding: '1rem', fontWeight: '600', border: 'none', textAlign: 'center' }}>Fechas</th>
                    <th style={{ padding: '1rem', fontWeight: '600', border: 'none', textAlign: 'center', minWidth: '200px' }}>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(getFilteredConvocatorias()) && getFilteredConvocatorias().map((conv) => {
                    const estadoBadge = getEstadoBadgeColor(conv.estado);
                    return (
                      <tr key={conv.nro_convocatoria} style={{ transition: 'background-color 0.2s' }}>
                        <td style={{ padding: '1rem', verticalAlign: 'middle' }}>
                          <strong style={{ color: '#667eea', fontSize: '1.05rem' }}>#{conv.nro_convocatoria}</strong>
                        </td>
                        <td style={{ padding: '1rem', verticalAlign: 'middle' }}>
                          <strong style={{ color: '#495057', fontSize: '1rem' }}>
                            {conv.COD_CONVOCATORIA || <span className="text-muted">N/A</span>}
                          </strong>
                        </td>
                        <td style={{ padding: '1rem', verticalAlign: 'middle' }}>
                          {conv.nro_pedido || <span className="text-muted">N/A</span>}
                        </td>
                        <td style={{ padding: '1rem', verticalAlign: 'middle' }}>
                          <div style={{ maxWidth: '200px' }}>
                            <div style={{ fontWeight: '500' }}>{conv.nombre_ejecutora || <span className="text-muted">N/A</span>}</div>
                            {conv.nombre_depend && (
                              <div style={{ fontSize: '0.85rem', color: '#6c757d', marginTop: '0.25rem' }}>
                                {conv.nombre_depend}
                              </div>
                            )}
                          </div>
                        </td>
                        <td style={{ padding: '1rem', verticalAlign: 'middle', maxWidth: '300px' }}>
                          <div style={{ 
                            maxHeight: '60px', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical'
                          }}>
                            {conv.motivo_pedido || <span className="text-muted">N/A</span>}
                          </div>
                        </td>
                        <td style={{ padding: '1rem', verticalAlign: 'middle' }}>
                          <span
                            style={{
                              display: 'inline-block',
                              padding: '0.35rem 0.75rem',
                              borderRadius: '20px',
                              fontSize: '0.85rem',
                              fontWeight: '600',
                              background: estadoBadge.bg,
                              color: estadoBadge.color,
                              border: `1px solid ${estadoBadge.border}`
                            }}
                          >
                            {conv.estado}
                          </span>
                        </td>
                        <td style={{ padding: '1rem', verticalAlign: 'middle', textAlign: 'center' }}>
                          <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>
                            {conv.fecha_inicio && (
                              <div><strong>Inicio:</strong> {new Date(conv.fecha_inicio).toLocaleDateString('es-PE')}</div>
                            )}
                            {conv.fecha_fin && (
                              <div><strong>Fin:</strong> {new Date(conv.fecha_fin).toLocaleDateString('es-PE')}</div>
                            )}
                            {!conv.fecha_inicio && !conv.fecha_fin && (
                              <span className="text-muted">Sin fechas</span>
                            )}
                          </div>
                        </td>
                        <td style={{ padding: '1rem', verticalAlign: 'middle', textAlign: 'center' }}>
                          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                            <button
                              onClick={() => handleView(conv.nro_convocatoria)}
                              className="btn btn-sm btn-info"
                              style={{
                                padding: '0.4rem 0.8rem',
                                fontSize: '0.85rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.25rem'
                              }}
                              title="Ver detalles"
                            >
                              <i className="bi bi-eye"></i>
                              Ver
                            </button>
                            <button
                              onClick={() => handleEdit(conv)}
                              className="btn btn-sm btn-success"
                              disabled={!!conv.orden_notificada}
                              style={{
                                padding: '0.4rem 0.8rem',
                                fontSize: '0.85rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.25rem',
                                opacity: conv.orden_notificada ? 0.55 : 1,
                                cursor: conv.orden_notificada ? 'not-allowed' : 'pointer',
                              }}
                              title={
                                conv.orden_notificada
                                  ? 'No editable: ya se notificó la orden al proveedor'
                                  : 'Editar convocatoria'
                              }
                            >
                              <i className="bi bi-pencil"></i>
                              Editar
                            </button>
                            <button
                              onClick={() => handleDelete(conv.nro_convocatoria)}
                              className="btn btn-sm btn-danger"
                              disabled={conv.total_cotizaciones > 0}
                              style={{
                                padding: '0.4rem 0.8rem',
                                fontSize: '0.85rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.25rem',
                                opacity: conv.total_cotizaciones > 0 ? 0.5 : 1,
                                cursor: conv.total_cotizaciones > 0 ? 'not-allowed' : 'pointer'
                              }}
                              title={conv.total_cotizaciones > 0 
                                ? `No se puede eliminar. La convocatoria tiene ${conv.total_cotizaciones} cotización${conv.total_cotizaciones !== 1 ? 'es' : ''} asociada${conv.total_cotizaciones !== 1 ? 's' : ''}`
                                : "Eliminar convocatoria"}
                            >
                              <i className="bi bi-trash"></i>
                              Eliminar
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Modal de Detalles de Convocatoria */}
      {showDetails && detalleConvocatoria && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '20px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '10px',
            padding: '2rem',
            maxWidth: '1200px',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            width: '100%'
          }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h2 className="h4 mb-1 fw-bold">Detalles de Convocatoria</h2>
                <p className="text-muted mb-0">#{detalleConvocatoria.nro_convocatoria}</p>
              </div>
              <button
                onClick={() => {
                  setShowDetails(false);
                  setDetalleConvocatoria(null);
                  setDetalleOrdenes([]);
                }}
                className="btn btn-outline-secondary"
              >
                <i className="bi bi-x-circle me-2"></i>
                Cerrar
              </button>
            </div>

            {/* Información de la Convocatoria */}
            <div style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f7fafc', borderRadius: '8px' }}>
              <h3 style={{ marginTop: 0, marginBottom: '1rem', color: '#2c3e50' }}>Información General</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div>
                  <strong>Rubro:</strong> {detalleConvocatoria.rubro || 'N/A'}
                </div>
                <div>
                  <strong>Concepto:</strong> {detalleConvocatoria.concepto || 'N/A'}
                </div>
                <div>
                  <strong>Estado:</strong> {detalleConvocatoria.estado}
                </div>
                <div>
                  <strong>Año Eje:</strong> {detalleConvocatoria.ano_eje || 'N/A'}
                </div>
                <div>
                  <strong>Nro Pedido:</strong> {detalleConvocatoria.nro_pedido || 'N/A'}
                </div>
                <div>
                  <strong>Ejecutora:</strong> {detalleConvocatoria.nombre_ejecutora || 'N/A'}
                </div>
                <div>
                  <strong>Tipo Bien:</strong> {detalleConvocatoria.tipo_bien || 'N/A'}
                </div>
                <div>
                  <strong>Tipo Pedido:</strong> {detalleConvocatoria.tipo_pedido || 'N/A'}
                </div>
                <div>
                  <strong>Centro de Costo:</strong> {detalleConvocatoria.centro_costo || 'N/A'}
                </div>
                <div>
                  <strong>Dependencia:</strong> {detalleConvocatoria.nombre_depend || 'N/A'}
                </div>
                {detalleConvocatoria.fecha_pedido && (
                  <div>
                    <strong>Fecha Pedido:</strong> {new Date(detalleConvocatoria.fecha_pedido).toLocaleDateString()}
                  </div>
                )}
                {detalleConvocatoria.fecha_inicio && (
                  <div>
                    <strong>Fecha Inicio:</strong> {new Date(detalleConvocatoria.fecha_inicio).toLocaleDateString()}
                  </div>
                )}
                {detalleConvocatoria.fecha_fin && (
                  <div>
                    <strong>Fecha Fin:</strong> {new Date(detalleConvocatoria.fecha_fin).toLocaleDateString()}
                  </div>
                )}
              </div>
              {detalleConvocatoria.motivo_pedido && (
                <div style={{ marginTop: '1rem' }}>
                  <strong>Motivo del Pedido:</strong>
                  <div style={{ background: 'white', padding: '1rem', borderRadius: '5px', marginTop: '0.5rem' }}>
                    {detalleConvocatoria.motivo_pedido}
                  </div>
                </div>
              )}
            </div>

            {/* Lista de Items/Órdenes */}
            <div>
              <h3 style={{ marginBottom: '1rem', color: '#2c3e50' }}>Items de la Convocatoria ({detalleOrdenes.length})</h3>
              {detalleOrdenes.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                  No hay items registrados para esta convocatoria.
                </div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
                    <thead>
                      <tr style={{ background: '#667eea', color: 'white' }}>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Secuencia</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Item</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Nombre Item</th>
                        <th style={{ padding: '0.75rem', textAlign: 'right', border: '1px solid #ddd' }}>Cantidad</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Unidad Medida</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Características</th>
                        <th style={{ padding: '0.75rem', textAlign: 'left', border: '1px solid #ddd' }}>Detalles</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detalleOrdenes.map((orden) => (
                        <tr key={orden.id_orden} style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{orden.secuencia}</td>
                          <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>
                            {orden.grupo_bien}-{orden.clase_bien}-{orden.familia_bien}-{orden.item_bien}
                          </td>
                          <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{orden.nombre_item || 'N/A'}</td>
                          <td style={{ padding: '0.75rem', textAlign: 'right', border: '1px solid #ddd' }}>{Math.round(Number(orden.cant_solicitada || 0))}</td>
                          <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{orden.unidad_medida || 'UN - Unidad'}</td>
                          <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{orden.caracteristicas || '-'}</td>
                          <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{orden.detalles || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal de Notificaciones */}
      <NotificationModal
        show={notification.show}
        onClose={() => setNotification({ ...notification, show: false })}
        title={notification.title}
        message={notification.message}
        type={notification.type}
        onConfirm={notification.onConfirm}
        showCancel={notification.type === 'confirm'}
      />
    </div>
  );
};

export default Convocatorias;